<template>
  <div id="booking-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        :ref="searchItemConfigModule"
        :config-module="searchItemConfigModule"
        :is-collapse-list="true"
        :grid-options="gridOptions"
        :is-append-query="true"
        grid-config-module="130002"
        :reset="true"
        lob="SI"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :custom-search-items="customSearchItems"
        :record-expand-status="true"
        :input-enter-query="true"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <div slot="operations">
          <el-button no="1" :disabled="!selectedJob || total <= 0 || hqDisabledViewDetail || (!isHQ && !validSingleSelect) || hierarchyDisabledViewDetail" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <el-button no="2" :disabled="!(selectedJob && Number(selectedJob.jobState) === 0 && !JobUtils.isBlockJob(selectedJob)) || !validSingleSelect || !hierarchyValidSingleSelect" type="success" @click="toEdit()">{{ $t('common.btn.edit') }}</el-button>
          <el-button
            v-show="$checkPermission(['button_SIBooking_addSIBooking']) && !$checkPermission(['button_Job_importOrderExcel'])"
            no="3"
            :disabled="hqDisabledOperate"
            type="primary"
            style="margin-right: 5px"
            @click="toAdd()"
          >
            {{ $t('common.btn.new') }}
          </el-button>
          <el-dropdown
            v-show="$checkPermission(['button_SIBooking_addSIBooking']) && $checkPermission(['button_Job_importOrderExcel'])"
            no="exportOrderHandle"
            :disabled="hqDisabledOperate"
            split-button
            type="primary"
            style="margin:0 5px"
            @click="exportOrderHandle()"
            @command="p=>{exportOrderCommand=p;exportOrderHandle()}"
          >
            <span v-if="exportOrderCommand !== $t('SeaExport.import')">{{ exportOrderCommand }}</span>
            <el-upload
              v-if="exportOrderCommand === $t('SeaExport.import')"
              :action="actionOrderUrl"
              :headers="headers"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :before-upload="beforeOrderUpload"
              :on-success="uploadOrderSuccess"
              :data="{branchId:$store.getters.currentOfficeId, lob:'SI'}"
              style="display: inline-block; margin-left: 5px"
            >
              <span style="color: white">{{ $t('SeaExport.import') }}</span>
            </el-upload>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.Add')">
                {{ $t('SeaExport.Add') }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.import')">
                <el-upload
                  ref="uploadOrder"
                  :action="actionOrderUrl"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadOrderSuccess"
                  :data="{branchId:$store.getters.currentOfficeId, lob:'SI'}"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">{{ $t('SeaExport.import') }}</el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item :command="$t('CargoMsg.Cargo_DownImportTemplate')">
                {{ $t('CargoMsg.Cargo_DownImportTemplate') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-show="$checkPermission(['button_deleteSIJob'])" no="4" :disabled="!validMultipleSelect" type="danger" @click="toDelete()">{{ $t('SeaExport.Delete') }}</el-button>
          <el-button v-show="$checkPermission(['button_SIBooking_addSIBooking'])" no="5" :disabled="!selectedJob || !validSingleSelect || !hierarchyValidSingleSelect" type="primary" @click="toCopy()">{{ $t('SeaExport.Clone') }}</el-button>
          <el-upload
            no="6"
            :disabled="hqDisabledOperate"
            :action="actionUrl"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".csv"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            style="display: inline-block;margin: 0 0 0 5px"
          >
            <el-button :disabled="hqDisabledOperate" type="primary" @click="onPayInfoImportClick">{{ $t('SeaExport.PaymentInformationImport') }}</el-button>
          </el-upload>
          <!--  <el-button type="primary" @click="paymentImportClickHandler()">{{ $t('SeaExport.PaymentInformationImport') }}</el-button>-->
          <el-button v-show="btnInfo.visible.btnPreSubmit" no="7" :disabled="!validSingleSelect || !hierarchyValidSingleSelect" type="primary" style="margin-left: 5px;" @click="doSubmitPrint_PreSubmit()">{{ $t('SeaExport.PreSubmission') }}</el-button>
          <el-button v-show="btnInfo.visible.btnSubmit" no="8" :disabled="!validSingleSelect || !hierarchyValidSingleSelect" type="primary" @click="doSubmitPrint_Submit()">{{ $t('SeaExport.Submission') }}</el-button>
          <el-button v-show="btnInfo.visible.btnManagerSubmit" no="9" :disabled="!validSingleSelect" type="primary" @click="doSubmitPrint_ManagerSubmit()">{{ $t('SeaExport.ManagerSubmission') }}</el-button>
          <!--审核-->
          <!--  <el-button v-show="btnInfo.visible.btnManagerAuditSubmit" type="primary" @click="doSubmitAudit_ManagerSubmit">{{ $t('SeaExport.Audit') }}</el-button>-->
          <!--退回-->
          <el-button v-show="btnInfo.visible.printReturnOperate" no="10" :disabled="!validSingleSelect || !hierarchyValidSingleSelect" type="primary" @click="backReturn(true)">{{ $t('SeaExport.ReturnAction') }}</el-button>
          <!--撤回-->
          <el-button v-show="btnInfo.visible.printReturn" no="11" :disabled="!validSingleSelect || !zyHierarchyValidSingleSelect" type="primary" @click="backReturn(false)">{{ $t('SeaExport.PrintReturn') }}</el-button>
          <el-button no="12" :disabled="!validMultipleSelect" type="primary" @click="toStatistics()">{{ $t('SeaExport.Statistics') }}</el-button>
          <!-- <el-button v-show="$checkPermission(['button_print_batchPrint'])" no="13" :disabled="!validMultipleSelect" type="primary" @click="onBatchPrint">{{ $t('SeaExport.BatchPrint') }}</el-button> -->
          <el-dropdown
            v-show="$checkPermission(['button_print_batchPrint'])"
            no="13"
            :disabled="!validMultipleSelect"
            split-button
            type="primary"
            style="margin-left: 5px;"
            @click="onBatchPrint($t('SeaExport.BatchPrint'))"
            @command="onBatchPrint"
          >
            {{ $t('SeaExport.BatchPrint') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('queryJob.PrintByBusinessNumber')">{{ $t('queryJob.PrintByBusinessNumber') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            no="14"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchHandle"
          >
            <el-button type="primary" :disabled="!btnInfo.batchSelectFlag || !validMultipleSelect">
              {{ $t('SeaExport.BatchProcessing') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="$checkPermission(['button_SIBooking_BatchShutOut'])" :command="23">{{ $t('SeaExport.BatchShutOut') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchPerCommit'])" :command="1">{{ $t('SeaExport.BatchPreSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchCommit'])" :command="2">{{ $t('SeaExport.BatchCommit') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchManagerSubmission'])" :command="3">{{ $t('SeaExport.BatchManagerSubmission') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_SIBooking_BatchVessel'])" :command="27">{{ $t('SeaExport.BatchVessel') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnToOperater'])" :disabled="!$checkPermission(['button_JobBooking_ReturnToOperater'])" :command="4">{{ $t('SeaExport.BatchReturnPreSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_Retract'])" :disabled="!$checkPermission(['button_JobBooking_Retract'])" :command="5">{{ $t('SeaExport.BatchReturnSubmit') }}</el-dropdown-item>

              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchUnlockReceivable'])" :command="6">{{ $t('SeaExport.BatchUnlockReceivableExpenses') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchUnlockPayable'])" :command="7">{{ $t('SeaExport.BatchUnlockPayableFees') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockReceivable'])" :command="8">{{ $t('SeaExport.BatchLockingReceivableExpenses') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockPayable'])" :command="9">{{ $t('SeaExport.BatchLockingPayableFees') }}</el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_SIBooking_BatchUpdateCustomJobType'])"
                :disabled="!$checkPermission(['button_SIBooking_BatchUpdateCustomJobType'])"
                :command="10"
              >{{ $t('SeaExport.BatchUpdateCustomJobType') }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_SIBOOKING_BatchUpdateJobInfo'])" :command="17">{{ $t('SeaExport.BatchModifyBusiness') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_jobSopTab_BatchReplaceTemplate'])" :command="18">{{ $t('SeaExport.ReplaceSOPTemplatesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="useOrderCenterMode&&!isRegionalCommission" :command="19">{{ $t('queryJob.BatchInitiateCollaboration') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchFillGpExplain'])" :command="20">{{ $t('SeaExport.BatchFillGpExplain') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchLockJob'])" :command="21">{{ $t('CargoMsg.Cargo_BatchServiceLocking') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchUnlockJob'])" :command="22">{{ $t('CargoMsg.Cargo_UnlockServicesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="openMutualTrustConfig" :command="24">{{ $t('SeaExport.BatchPushCharges') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnReview'])" :command="28">{{ $t('CargoMsg.Cargo_BatchReturnPreApproval') }}</el-dropdown-item>
              <!-- 指令操作按钮 -->
              <template v-for="(item, index) in instructioinBtns">
                <el-dropdown-item
                  :key="'instruction' + index"
                  :disabled="!item.allowOperate"
                  :command="'instruction,' + item.tenantInstructionUuid"
                >
                  {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button no="15" :disabled="!validMultipleSelect" type="primary" @click="editState">{{ $t('SeaExport.EditSopStatus') }}</el-button>
          <el-dropdown
            v-show="$checkPermission(['tab_Charge_chargeView'])"
            no="16"
            :disabled="!validMultipleSelect"
            split-button
            type="primary"
            style="margin-left: 5px"
            @click="chargeHandle"
            @command="p=>{chargeCommand=p;chargeHandle()}"
          >
            {{ chargeCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.AddCharges')">{{ $t('SeaExport.AddCharges') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.EditCharges')">{{ $t('SeaExport.EditCharges') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.DeleteCharges')">{{ $t('SeaExport.DeleteCharges') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.ChargeImport')">{{ $t('SeaExport.ChargeImport') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="!($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)" no="17" :disabled="!validMultipleSelect" split-button type="primary" style="margin-left: 5px" @click="exportHandle()" @command="p=>{exportCommand=p;exportHandle()}">
            {{ exportCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.ExportToExcel')">{{ $t('SeaExport.ExportToExcel') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.ExportWithSOPToExcel')">{{ $t('SeaExport.ExportWithSOPToExcel') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!--          <el-button v-show="$checkPermission(['button_SEBooking_addLCL'])" type="success" @click="toAdd({masterFlag: true})">{{ $t('SeaExport.AddHbl') }}</el-button>-->
          <!--          <el-button type="primary" :disabled="!btnInfo.enableBtnSplit" @click="toSplit()">{{ $t('SeaExport.SplitHbl') }}</el-button>-->

          <!-- LTS同步-->
          <el-dropdown
            v-show="toExoSystemYGSH && $checkPermission(['button_Charge_ltsSync'])"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchLtsSyncHandle"
          >
            <el-button type="primary" :disabled="!btnInfo.batchSelectFlag || !validMultipleSelect">
              {{ $t('CargoMsg.Cargo_SynchronousCloudPlatform') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">{{ $t('SeaExport.receivable') }}</el-dropdown-item>
              <el-dropdown-item :command="2">{{ $t('SeaExport.payable') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid-wrapper
          config-module="130002"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :locale-text-func="_i18nGridLocalText"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-selected-color="false"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          style="width: 100%;"
          @gridReady="onGridReady"
          @columnRowGroupChanged="() => { this.$refs[searchItemConfigModule].clickCollapseList() }"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery && total>0"
          config-module="130002"
          :total="total"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :selected-row-count="selectedRowCount"
          @pagination="()=>{if(total>0){toQuery()}}"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!-- 状态修改弹窗 -->
    <state-dialog
      v-if="stateDialog.visible"
      :visible.sync="stateDialog.visible"
      :rows="stateDialog.rows"
      :tracking-list="stateDialog.trackingList"
      @callback="toQuery()"
    />
    <!-- 批量退关弹窗 -->
    <el-dialog
      v-if="shutOutDialog.visible"
      v-el-drag-dialog
      no="23"
      :visible.sync="shutOutDialog.visible"
      :title="$t('Message.Warning')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;padding-left:30px">
        <span style="line-height: 40px;">{{ $t('Message.PleaseConfirmTheShutOut') }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip1 }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip2 }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="24" type="primary" @click="hasChargeShutoutHandler()">{{ $t('Message.HasChargeToShutOut') }}</el-button>
        <el-button no="25" :style="{ display: shutOutDialog.shutOutButtonShow2 }" type="primary" @click="noHasChargeShutoutHandler()">{{ $t('Message.NoChargeToShutOut') }}</el-button>
        <el-button no="26" @click="shutOutDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量转船弹窗 -->
    <el-dialog
      v-if="transshipDialog.visible"
      v-el-drag-dialog
      no="27"
      :visible.sync="transshipDialog.visible"
      :title="$t('SeaExport.BatchVessel')"
      :width="$selectByLang('850px', '850px', '850px', '900px', '900px', '900px')"
      :close-on-click-modal="false"
    >
      <div style="display: flex">
        <el-form label-width="120px" label-position="left" style="padding-right: 20px">
          <el-form-item :label="$t('SeaExport.Vessel')">
            <div style="display: flex">
              <el-input v-model="transshipDialog.vessel" :disabled="clearCheckBox.vessel" />
              <el-checkbox v-model="clearCheckBox.vessel" style="margin-left: 10px" @change="clearCheckBoxChange('vessel')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PortOfLoading')">
            <div style="display: flex">
              <cargo-advance-select
                style="width:195px;"
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                :disabled="clearCheckBox.loadingPortCode"
                :default-value="transshipDialog.loadingPortCode"
                @parentCallBack="p=>{transshipDialog.loadingPortCode = p.value}"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ShippingCompany')">
            <div style="display: flex">
              <cargo-advance-select
                :disabled="clearCheckBox.carrierId"
                filterable
                style="width:195px;"
                options-width="200px;"
                :method-params="{seaCmp:true,active:true}"
                :select-type="selectTypeNames.basic_data_Company"
                :default-value="transshipDialog.txtCarrierId||''"
                @parentCallBack="onCarrierIdSelectionChange"
              />
              <el-checkbox v-model="clearCheckBox.carrierId" style="margin-left: 10px" @change="clearCheckBoxChange('carrierId')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfDeparture2')">
            <el-date-picker
              v-model="transshipDialog.etd"
              :disabled="clearCheckBox.etd"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:195px;"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ActualDateOfDeparture2')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.atd"
                :disabled="clearCheckBox.atd"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:195px;"
              />
              <el-checkbox v-model="clearCheckBox.atd" style="margin-left: 10px" @change="clearCheckBoxChange('atd')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" label-position="left">
          <el-form-item :label="$t('SeaExport.Voyage')">
            <div style="display: flex">
              <el-input v-model="transshipDialog.voyageFlight" :disabled="clearCheckBox.voyageFlight" />
              <el-checkbox v-model="clearCheckBox.voyageFlight" style="margin-left: 10px" @change="clearCheckBoxChange('voyageFlight')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PortOfDischarge')">
            <div style="display: flex">
              <cargo-advance-select
                :disabled="clearCheckBox.dischargingPortCode"
                style="width:195px;"
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                :default-value="transshipDialog.dischargingPortCode"
                @parentCallBack="p=>{transshipDialog.dischargingPortCode = p.value}"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BookingAgent')">
            <div style="display: flex">
              <cargo-advance-select
                :disabled="clearCheckBox.bookingAgent"
                filterable
                style="width:195px;"
                options-width="200px;"
                :method-params="{bookingAgent:true,active:true}"
                :select-type="selectTypeNames.basic_data_Company"
                :default-value="transshipDialog.txtBookingAgent||''"
                @parentCallBack="p=>transshipDialog.txtBookingAgent=p.cmpIdx"
              />
              <el-checkbox v-model="clearCheckBox.bookingAgent" style="margin-left: 10px" @change="clearCheckBoxChange('bookingAgent')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfArrival2')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.eta"
                :disabled="clearCheckBox.eta"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:195px;"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ActualDateOfArrival2')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.ata"
                :disabled="clearCheckBox.ata"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:195px;"
              />
              <el-checkbox v-model="clearCheckBox.ata" style="margin-left: 10px" @change="clearCheckBoxChange('ata')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="33" type="primary" @click="transShipClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="34" @click="transshipDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量修改整拼类型弹窗 -->
    <el-dialog
      v-if="fullSpellTypeDialog.visible"
      v-el-drag-dialog
      no="35"
      :visible.sync="fullSpellTypeDialog.visible"
      :title="$t('SeaExport.BatchUpdateType')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="left">
        <el-form-item :label="$t('queryJob.BatchOfWholeSplicingType')" class="custom">
          <el-select v-model="fullSpellTypeDialog.containerLoadType" style="width:190px">
            <el-option
              v-for="(item,index) in fullSpellTypeDialog.containerLoadTypes"
              :key="index"
              :label="item.chineseName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="36" type="primary" @click="fullSpellTypeClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="37" @click="fullSpellTypeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 统计弹窗 -->
    <el-dialog
      v-if="statisticsDialog.visible"
      v-el-drag-dialog
      no="38"
      :visible.sync="statisticsDialog.visible"
      :title="$t('SeaExport.Statistics')"
      :width="$selectByLang('360px', '445px')"
      :close-on-click-modal="false"
    >
      <el-form :label-width="$selectByLang('85px', '170px')" label-position="left">
        <el-form-item :label="$t('SeaExport.Slaves')" class="custom">
          <el-input v-model="statisticsDialog.txtSlaves" no="39" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Master')" class="custom">
          <el-input v-model="statisticsDialog.txtMaster" no="40" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TotalTickets')" class="custom">
          <el-input v-model="statisticsDialog.txtCount" no="41" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CustomerCount')" class="custom">
          <el-input v-model="statisticsDialog.txtCustomerCount" no="42" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="20＇" class="custom">
          <el-input v-model="statisticsDialog.txt20" no="43" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="40＇" class="custom">
          <el-input v-model="statisticsDialog.txt40" no="44" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="40HQ＇" class="custom">
          <el-input v-model="statisticsDialog.txt40hq" no="45" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="45＇" class="custom">
          <el-input v-model="statisticsDialog.txt45" no="46" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="TEU" class="custom">
          <el-input v-model="statisticsDialog.txtTeu" no="47" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Weight2')" class="custom">
          <el-input v-model="statisticsDialog.txtWeight" no="48" style="width:160px" :disabled="true" />
          <span>KGS</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Cubage')" class="custom">
          <el-input v-model="statisticsDialog.txtCubage" no="49" style="width:160px" :disabled="true" />
          <span>CBM</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ChargedWeight')" class="custom">
          <el-input v-model="statisticsDialog.txtChargeWeight" no="50" style="width:160px" :disabled="true" />
          <span>M/T</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.SpecifyAgentNumber')" class="custom">
          <el-input v-model="statisticsDialog.txtdesignationAgentNum" no="51" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label-width="0" class="custom">
          <el-checkbox v-model="statisticsDialog.containShutOutJob" @change="handleStatistics(true)">{{ $t('SeaExport.ContainShutOutJob') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statisticsDialog.visible = false">{{ $t('Message.Close') }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增费用弹窗 -->
    <add-charge-detail-dialog
      v-if="addChargeDetailDialog.visible"
      :visible.sync="addChargeDetailDialog.visible"
      :selected-jobs="addChargeDetailDialog.selectedJobs"
      :charge-type="addChargeDetailDialog.type"
      lob="SI"
      :location="location"
      :selected-scheme="addChargeDetailDialog.selectedScheme"
      @toChangeSchema="toChangeSchema"
    />
    <!-- 编辑费用弹窗 -->
    <edit-charge-detail-dialog
      v-if="editChargeDetailDialog.visible"
      :visible.sync="editChargeDetailDialog.visible"
      :selected-jobs="editChargeDetailDialog.selectedJobs"
      :charge-type="editChargeDetailDialog.chargeType"
      lob="SI"
    />
    <!-- 删除费用弹窗 -->
    <delete-charge-detail-dialog
      v-if="deleteChargeDetailDialog.visible"
      :visible.sync="deleteChargeDetailDialog.visible"
      :selected-jobs="deleteChargeDetailDialog.selectedJobs"
      :charge-type="deleteChargeDetailDialog.chargeType"
      lob="SI"
    />
    <!-- 费用导入弹窗 -->
    <charge-scheme-batch-dialog
      v-if="chargeSchemeBatchDialog.visible"
      :visible.sync="chargeSchemeBatchDialog.visible"
      :selected-jobs="chargeSchemeBatchDialog.selectedJobs"
      :job="chargeSchemeBatchDialog.job"
      :need-check-range="chargeSchemeBatchDialog.needCheckRange"
      :lob="chargeSchemeBatchDialog.lob"
      :is-sea="chargeSchemeBatchDialog.isSea"
      :original-condition="chargeSchemeBatchDialog.originalCondition"
      :charge-scheme-is-approved="chargeSchemeBatchDialog.chargeSchemeIsApproved"
      :location="location"
      :charge-type="chargeSchemeBatchDialog.chargeType"
      :source="chargeSchemeBatchDialog.source"
      @selectedSchemeHandler="handleSelectedScheme"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />

    <!-- Lts批量同步费用 -->
    <lts-batch-sync
      ref="ltsBatchSyncCharge"
      :visible.sync="ltsWindow.visible"
      :keys="ltsWindow.keys"
    />
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
      :is-submit="true"
    />
    <!-- 批量修改业务弹窗 -->
    <batch-modify-business-dialog
      :visible.sync="batchModifyBusinessDialog.visible"
      :job-keys="batchModifyBusinessDialog.jobKeys"
      :job-list="batchModifyBusinessDialog.jobList"
      :lob="batchModifyBusinessDialog.lob"
      @callback="batchModifyBusinessCallback"
    />
    <!-- 批量修改业务SOP模板弹窗 -->
    <change-sop-template-dialog
      :visible.sync="changeSopTemplateDialog.visible"
      :lob="lob"
      :job-list="changeSopTemplateDialog.jobList"
      @reload="reload"
    />
    <!-- 批量协作弹窗 -->
    <batch-cooperation-dialog :visible.sync="batchCooperationDialog.visible" :job-list="batchCooperationDialog.jobList" :order-center-branch="orderCenterBranch" />
    <!-- 下载导入模板弹窗 -->
    <download-import-template-dialog
      :visible.sync="downloadImportTemplateDialog.visible"
      :lob="downloadImportTemplateDialog.lob"
    />
    <!-- 业务申请审批流 实质是：job-apply-dialog-->
    <job-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      :visible.sync="workFlowApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_Approving')"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      :doc-id="workFlowApplyDialog.documentProcess.docId"
      :document-config-id="workFlowApplyDialog.documentProcess.documentConfigId"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible = false
        toQuery()
      }"
    />
    <!-- GP说明-->
    <add-gp-explain-dialog
      v-if="gpExplain.visible"
      :type="gpExplain.type"
      :visible.sync="gpExplain.visible"
      :job-uuids="gpExplain.jobUuids"
    />
    <!-- 批量修改自定义业务类型弹窗 -->
    <el-dialog
      v-if="customJobTypeDialog.visible"
      v-el-drag-dialog
      :visible.sync="customJobTypeDialog.visible"
      :title="$t('SeaExport.BatchUpdateCustomJobType')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="left">
        <el-form-item :label="$t('SeaExport.CustomJobType')+':'">
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_CutomJobType"
            filterable
            :method-params="{type: SystemConstants.SI.code, active: true}"
            :default-value="customJobTypeDialog.customJobType"
            @parentCallBack="p=>{customJobTypeDialog.customJobType=p.value}"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="customJobTypeClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="customJobTypeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      lob="SI"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="list"
      @confirm="toQuery()"
    />

    <!-- 应收应付类型选择弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="chargeTypeDialog.visible"
      :title="$t('CargoMsg.Cargo_AddCostType')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="margin: 30px 30px;">
        <el-radio-group v-model="chargeTypeDialog.type" size="small">
          <el-radio :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
          <el-radio :label="2">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
          <el-radio :label="0">{{ $t('CargoMsg.Cargo_ARAP') }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="onChargeTypeDialogConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="chargeTypeDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 同租户交叉委托窗口 -->
    <tenant-entrust-window ref="tenantEntrustWindow" @instructionCallback="onInstructionCallback" />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'

import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import addChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/addChargeDetailDialog'
import chargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { deepClone } from '@/utils'
import { DocumentManage, ensureExecuteSuccess, stopBubble, stringToBool } from '@/utils/commonUtil'
import hblIcon from '@/assets/h_resize.png'
import jobDetailIcon from '@/assets/job-detail.png'
import mblIcon from '@/assets/m_resize.png'
import { isArray } from '@/utils/validate'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import {
  batchDeleteJob,
  checkChargeStateVerify,
  batchPreCommit,
  batchCommit,
  checkJobHasContainer,
  updateJobContainerLoadType,
  statisticsJobs,
  batchCheckRemoveCharge,
  batchRemoveCharge,
  splitMaster,
  getTrackingListByLob,
  getTrackingDetailByTrackingUuid,
  canBatchShutout,
  batchShutout,
  isContractExpiredForbidCreateJob,
  getJobSopStates,
  commit,
  getChargeIsInvoice,
  saveJobInfo, calculateProfit, printProfit
} from '@/api/seaExport/seaExportJob'

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as TrackingConstants from '@/class/cargo/model/parameters/TrackingConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { getObjectByCache, getCacheListByKey, operateBranchIsOptional } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { formatNumberToThousands } from '@/utils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import {
  advancedQuery,
  findSeaImportJobByNo,
  queryLastModifyBookingByDay,
  getSeaImportJobByUuid,
  batchTransship
} from '@/api/SeaImport/seaImportJob'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { PrintUtils } from '@/utils/PrintUtils'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { getDocumentType } from '@/api/documentType'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { sendSapMessageByJob } from '@/api/clearing/charge'
import StrUtils from '@/utils/StrUtils'
import { Company } from '@/class/model/mdm/Company'
import { getCustomerTypeList } from '@/api/basicData/customerType'
import {
  batchManagerCommit,
  batchModifyChargeLockStatus,
  batchReturnSubmit,
  getJobByUuid, syncChargeConfirmBatch, updateJobCustomJobType,
  validateChargeLockStatus, validateJobForDelete
} from '@/api/booking/job'
import { getToken } from '@/utils/auth'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { OPERATOR_EQUAL } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { getFilterCacheList } from '@/utils/basicDataCache'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { COMMITED, LOG_SI_SEA_BOOKING, OPERATE_PRINT_RETURN } from '@/class/cargo/model/parameters/SystemConstants'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import DateUtils from '@/utils/dateUtils'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import LtsBatchSync from '@/components/Cargo/Job/ltsBatchSync.vue'
import editChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/editChargeDetailDialog.vue'
import { recordSelectedStatus } from '@/utils/agGrid'
import StateDialog from '@/components/Cargo/Job/StateDialog'
import WorkflowConstants, {
  APPLICATION_DIMENSION_JOB_CHARGE,
  Job_CHARGE
} from '@/class/cargo/model/parameters/WorkflowConstants'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import DeleteChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/deleteChargeDetailDialog.vue'
import BatchModifyBusinessDialog from '@/views/cargo/v0/SeaExport/components/booking/batchModifyBusinessDialog.vue'
import ChangeSopTemplateDialog from '@/components/Cargo/Job/booking/tabs/changeSopTemplateDialog'
import BatchCooperationDialog from '@/components/Cargo/Job/BatchCooperationDialog'
import DownloadImportTemplateDialog
  from '@/views/cargo/v0/SystemMaintenance/components/orderTemplateConfig/downloadImportTemplateDialog'
import JobWorkFlowApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import BookingTreeGridMixin from '@/mixin/BookingTreeGridMixin'
import lodash from 'lodash'
import AddGpExplainDialog from '@/components/Cargo/Job/addGpExplainDialog.vue'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog'
import { getInstructions } from '@/api/sysManage/uiCustom'
import TenantEntrustWindow from '@/components/Cargo/Job/tenantEntrustWindow/index'

export default {
  name: 'BookingTreeGrid',
  components: {
    jobReturnReviewDialog,
    cargoCompanySelect,
    cargoAgGridWrapper,
    AddGpExplainDialog,
    ChangeSopTemplateDialog,
    BatchModifyBusinessDialog,
    DeleteChargeDetailDialog,
    CargoAdvanceSelect,
    LtsBatchSync,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog,
    addChargeDetailDialog,
    chargeSchemeBatchDialog,
    editChargeDetailDialog,
    BatchCheckingWindow,
    CheckingWindow,
    StateDialog,
    batchSubmitOrApproveDialog,
    BatchCooperationDialog,
    DownloadImportTemplateDialog,
    JobWorkFlowApplyDialog,
    TenantEntrustWindow
  },
  mixins: [BookingTreeGridMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    isQuery: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sessionId: getToken(),
      SystemConstants,
      manageAuditStatus: 0,
      commonInfo: {
        operateNameCode: -1, // 操作code
        isPreCommit: false, // 预提交
        isPrintCommit: false, // 打印利润分析表是否提交业务
        allSubmitFcl: false, // 主票提交时是否提交全部拼票业务
        reqInputCharge: false, // 是否必录费用
        checkEstimate: false, // 预估是否验证过
        isCopySellingCharge: false, // 复制应付费用
        needConfirmDuplicateWarehouseNo: false, // 是否要验证进仓编号重复
        synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false, // 提单收发通代码是否同步至基本页签收发通代码
        isPrint: true,
        isPrintOpr: false, // 是否打印操作（由于打印和提交中最后调用的有相同的方法，因此用改参数区分开来）
        detailTitleShowModel: 0, // 标题显示模式
        printEvent: null,
        showMessage: true,
        returnSend: false
      },
      ltsWindow: {
        visible: false,
        keys: [],
        anyBool: false
      },
      btnInfo: {
        enableBtnSplit: false, // 批量拆分主票
        batchSelectFlag: false, // 批量操作
        label: {
          shutOutLabel: this.$t('SeaExport.ShutOut'),
          btnEntrustment: this.$t('SeaExport.Consignation'), // 内部委托按钮
          btnProfit: this.$t('SeaExport.PrintFclProfit'),
          btnShutout: this.$t('SeaExport.ShutOut')
        },
        enabled: {
          btnProfit: true
        },
        visible: {
          sendBackBookingButton: false, // 发送订舱数据
          printFclProfit: false, // 整箱利润打印
          printLclProfit: false, // 拼箱利润打印
          cancelReturn: false, // 退回操作
          printReturn: false, // 撤回
          printReturnOperate: false,
          btnSubmit: false,
          btnManagerSubmit: false,
          btnPreSubmit: false,
          btnManagerAuditSubmit: false // 审核
        },
        privilege: {
          btnEntrustment: null, // 委托按钮是否禁用
          btnShutout: false, // 退关按钮是否可用
          consignationEnable: false, // 内部委托按钮是否可用
          consignationCrossEnable: false, // 跨分公司委托是否可用
          crossMoreSign: false,
          button_SEBooking_cancelShutout: this.$checkPermission(['button_SEBooking_cancelShutout']),
          button_JobBooking_Submit: this.$checkPermission(['button_JobBooking_Submit']),
          button_JobBooking_PreSubmit: this.$checkPermission(['button_JobBooking_PreSubmit']),
          button_JobBooking_ManagerSubmit: this.$checkPermission(['button_JobBooking_ManagerSubmit']),
          button_JobBooking_ManagerAuditSubmit: this.$checkPermission(['button_JobBooking_ManagerAuditSubmit']),
          button_JobBooking_PrintProfit: this.$checkPermission(['button_JobBooking_PrintProfit']),
          button_SEBooking_cancelProfit: this.$checkPermission(['button_SEBooking_cancelProfit']),
          button_JobBooking_Retract: this.$checkPermission(['button_JobBooking_Retract']),
          button_JobBooking_ReturnToOperater: this.$checkPermission(['button_JobBooking_ReturnToOperater'])
        }
      },
      customJobTypeDialog: {
        visible: false,
        jobKeys: [],
        jobList: [],
        customJobType: ''
      },
      currentRow: {},
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      ticketsMustBeVoted: false, // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      useCheckRule: false, // 是否启用验证规则
      allowPartialCheckPass: false, // CARGO-1677，批量提交业务时，部分业务不符合校验规则导致全部业务都无法提交
      checkApChargeVerify: false, // 业务预提交时是否验证应付费用已全部审核
      editVessel: '', // //订舱性质
      toExoSystemYGSH: false, // 阳光速航
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      notRefresh: false,
      filterJson: {},
      total: 0,
      pageCount: 0,
      JobUtils,
      selectedJob: null,
      perConfigName: '',
      gridRefreshId: 0,
      arSettlementUnitOptional: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const currentJob = params.data
              if (!currentJob) {
                return false
              }
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                return false
              }
              return true
            },
            innerRenderer: params => {
              const currentJob = params.data
              if (!currentJob) {
                return ''
              }
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
              }
              // const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}</span>`
            }
          }
        },
        // onRowClicked: this.onRowClicked,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
          this.onGridSelectionChanged(event)
          this.$refs[this.searchItemConfigModule].clickCollapseList()
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // // 选中 勾选框触发
        onRowSelected: (event) => {
          if (!event || !event.data) return
          this.$nextTick(async() => {
            // 等待gridApi被赋值
            await ensureExecuteSuccess(() => this.gridApi)
            const rows = this.gridApi.getSelectedRows()
            this.btnInfo.batchSelectFlag = rows.length > 0
          })
        },
        onSelectionChanged: event => {
          this.onGridSelectionChanged(event)
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          let data = event.data
          // 若选中提单拆并单,则需要找到其父级job
          if (data.dataType && Number(data.dataType) !== 1 && Number(data.dataType) !== 2 && data.jobUuid) {
            for (const item of this.rowData) {
              if (item.uuid === data.jobUuid) {
                data = item
                break
              }
            }
          }
          if (this.hierarchyViewList && !this.hierarchyViewDetail) {
            if (!this.matchOwnerBranch(data)) {
              return
            }
          }
          if (this.hqViewAllList) {
            const curOfficeId = this.$store.getters.currentOfficeId
            if (curOfficeId === 1) {
              if (!this.hqViewAllDetail) {
                return
              }
            } else {
              let needCheck = true
              if (!this.isZy && this.hierarchyViewDetail) {
                if (this.childOfficeIds.includes(data.opOffice) || this.childOfficeIds.includes(data.salesOffice)) {
                  needCheck = false
                }
              }
              if (needCheck) {
                if (data.opOffice !== curOfficeId && data.salesOffice !== curOfficeId && !this.mactchCooperateBranch(data.cooperatebranch, this.$store.getters.currentOffice)) {
                  return
                }
              }
            }
          }
          this.toLook(data)
        },
        getRowStyle: (params) => {
          if (!params.data) {
            return {}
          }
          const row = params.data
          const { colorSettings, colorType } = this
          if (!row) {
            return { 'background': '' }
          }
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
            if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
              Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
              JobUtils.isBlockJob(row)) {
              return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
            } else {
              const jobState = String(row.jobState) || ''
              for (const stateColor of colorSettings) {
                if (jobState === stateColor.colorKey) {
                  return { 'background': stateColor.colorValue }
                }
              }
            }
          }
          return {}
        },
        /* onSortChanged: (event) => {
          // this.$logger.log('onSortChanged-event', event)
          if (this.rowDataBeforeSort.length !== this.rowData.length) {
            this.rowDataBeforeSort = this.rowData
          }
          if (!event.api.getSortModel().length) {
            this.rowData = this.rowDataBeforeSort
            this.rowDataBeforeSort = []
          } else {
            this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
          }
        },*/
        context: {
          componentParent: this
        }
      },
      selectedRowCount: 0,
      dargGroupShowColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        wrapText: false,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            return false
          }
          return true
        },
        cellRenderer: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
            return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
          }
          return params.value
        },
        excelRenderer: params => params.value
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.ConsignationRelationNumber'),
          colId: 'trustFromJob',
          field: 'trustFromJob',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
          colId: 'relatedJob',
          field: 'relatedJob',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          colId: 'customerTypeId',
          field: 'customerTypeId',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', Number(params.value), 'chineseName')
          },
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_TransportSource'),
          colId: 'transportSource',
          field: 'transportSource',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TransportSource, 'code', params.value, this.isZh ? 'name' : 'englishName')
          },
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.ContractStatus'),
          colId: 'contractStatus',
          field: 'contractStatus',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_RiskReason'),
          colId: 'riskReason',
          field: 'riskReason',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          colId: 'cargoSalesId',
          field: 'cargoSalesId',
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCargoSalesId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.Hbl2'),
          field: 'hbl',
          colId: 'hbl',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.Mbl2'),
          field: 'mbl',
          colId: 'mbl',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: 'dischargingPortCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          field: 'chargeWeight',
          colId: 'chargeWeight',
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.value && parseInt(params.value) !== 0) return ''
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 120,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.PortOfLoadingAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.TheFirstVessel'),
          field: 'vessel',
          colId: 'vessel',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return ColumnUtils.taxNatureLabelFunction(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.HaulageCompany'),
          field: 'carryingCmp',
          colId: 'carryingCmp',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_11') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityContract',
          colId: 'quantityContract',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 120,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightContract',
          colId: 'weightContract',
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.value && parseInt(params.value) !== 0) return ''
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 120,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageContract',
          colId: 'cubageContract',
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.value && parseInt(params.value) !== 0) return ''
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 120,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.Consignee'),
          colId: 'consigneeLine1',
          field: 'consigneeLine1',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Shipper'),
          field: 'shipperLine1',
          colId: 'shipperLine1',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          enableRowGroup: true,
          width: 100,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          colId: 'cargoChineseName',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.ItemNo'),
          field: 'poNo',
          colId: 'poNo',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.CustomerReferenceNumber'),
          field: 'customerRefNo',
          colId: 'customerRefNo',
          enableRowGroup: true,
          width: 130
        }, {
          headerName: this.$t('SeaExport.FLCLType'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          cellRenderer: (params) => {
            if (!params.data) return ''
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          },
          /* 设置列筛选功能的过滤器 */
          filter: false,
          filterParams: {},
          width: 120
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'tmpContainerNo',
          field: 'tmpContainerNo',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.OperationDate'),
          field: 'customsDate',
          colId: 'customsDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.OverseaCustomerService'),
          colId: 'overseaOp',
          field: 'overseaOp',
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOverseaOp), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.FieldOperation'), field: 'siteOp', width: 180, colId: 'siteOp', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          field: 'cargoSource',
          colId: 'cargoSource',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture2'),
          field: 'etd',
          colId: 'etd',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.DateOfArrival2'),
          field: 'eta',
          colId: 'eta',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.ShutOut'),
          field: 'shutOut',
          colId: 'shutOut',
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.ShutOutDate'),
          field: 'shutOutDate',
          colId: 'shutOutDate',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.BillExchange'),
          field: 'bTransDate',
          colId: 'bTransDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.PickUpGoods'),
          field: 'bDeliverDate',
          colId: 'bDeliverDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          field: 'customJobType',
          colId: 'customJobType',
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.customJobType, 'name', SystemConstants.SI.code, false)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BillExchangeDate'),
          field: 'transDate',
          colId: 'transDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'exChangeAgent',
          colId: 'exChangeAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
          field: 'atd',
          colId: 'atd',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualDateOfArrival2'),
          field: 'ata',
          colId: 'ata',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Storage'),
          field: 'warehousing',
          colId: 'warehousing',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.Devanning'),
          field: 'parts',
          colId: 'parts',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.DeliveryToDoor'),
          field: 'landTransportation',
          colId: 'landTransportation',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.CustomsDeclaration'),
          field: 'customs',
          colId: 'customs',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'dateCreated',
          colId: 'dateCreated',
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateSales), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Accrued'),
          field: 'provisioned',
          colId: 'provisioned',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          hide: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOpId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCsrId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Documents'),
          field: 'dc',
          colId: 'dc',
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateDcId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Status'),
          field: 'jobState',
          colId: 'jobState',
          cellRenderer: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.ContractRateProperty'),
          field: 'bookingTerm',
          colId: 'bookingTerm',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.bookingTermSILabelFunction(params.data, params.value)
          },
          filter: false,
          filterParams: {},
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
          field: 'scNo',
          colId: 'scNo',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessPushStatus'),
          colId: 'jobPushStatus',
          field: 'jobPushStatus',
          width: 100,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.jobPushStatusLabelFunc(Number(params.value))
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          colId: 'remarks',
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.SOPStatus'),
          field: 'sopState',
          colId: 'sopState',
          enableRowGroup: true,
          width: 150,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          field: 'userDefinedField1',
          colId: 'userDefinedField1',
          hide: true,
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          field: 'userDefinedField2',
          colId: 'userDefinedField2',
          hide: true,
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          field: 'userDefinedField3',
          colId: 'userDefinedField3',
          hide: true,
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.ManageAuditStatus'),
          field: 'manageAuditStatus',
          colId: 'manageAuditStatus',
          hide: true,
          enableRowGroup: true,
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.manageAuditStatusLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          colId: 'incoTerm',
          hide: true,
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.UserDefinedField4'),
          field: 'userDefinedField4',
          colId: 'userDefinedField4',
          hide: true,
          enableRowGroup: true,
          width: 120
        }, {
          headerName: this.$t(' SeaExport.HBLBlType'),
          field: 'hblReleaseType',
          colId: 'hblReleaseType',
          hide: true,
          enableRowGroup: true,
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.releaseTypeLabelFunction(params.value)
          }
        }, {
          headerName: this.$t(' SeaExport.DateOfDelivery'),
          field: 'deliverDate',
          colId: 'deliverDate',
          hide: true,
          enableRowGroup: true,
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'),
          field: 'receivableChargeLockedStatus',
          colId: 'receivableChargeLockedStatus',
          hide: true,
          width: 150,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.PayableChargeLockedStatus'),
          field: 'payableChargeLockedStatus',
          colId: 'payableChargeLockedStatus',
          hide: true,
          enableRowGroup: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.ChannelNo'),
          field: 'channelNo',
          colId: 'channelNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Airline'),
          field: 'regionName',
          colId: 'regionName',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          width: 200,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_5') : ''
          }
        }, {
          headerName: this.$t('SeaExport.FinalDestination'),
          colId: 'destinationPlace',
          field: 'destinationPlace',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          enableRowGroup: true,
          width: 150,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId1), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          enableRowGroup: true,
          width: 150,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId2), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
          field: 'userDefinedRoleId3',
          colId: 'userDefinedRoleId3',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
          field: 'userDefinedRoleId4',
          colId: 'userDefinedRoleId4',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
          field: 'userDefinedRoleId5',
          colId: 'userDefinedRoleId5',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
          field: 'userDefinedRoleId6',
          colId: 'userDefinedRoleId6',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
          field: 'userDefinedRoleId7',
          colId: 'userDefinedRoleId7',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.PreCommitUser'),
          field: 'preCommitUser',
          colId: 'preCommitUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.PreCommitDate'),
          field: 'preCommitDate',
          colId: 'preCommitDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CommitUser'),
          field: 'commitUser',
          colId: 'commitUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.SubmissionDate'),
          field: 'submissionDate',
          colId: 'submissionDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FcAuditUser'),
          field: 'fcAuditUser',
          colId: 'fcAuditUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FcAuditDate'),
          field: 'fcAuditDate',
          colId: 'fcAuditDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobUser'),
          field: 'lockJobUser',
          colId: 'lockJobUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobDate'),
          field: 'lockJobDate',
          colId: 'lockJobDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
          field: 'salesOffice',
          colId: 'salesOffice',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateSalesOffice), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          field: 'opOffice',
          colId: 'opOffice',
          hide: true,
          width: 100,
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateOpCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
          field: 'salesDepartment',
          colId: 'salesDepartment',
          hide: true,
          width: 100,
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateSalesDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
          field: 'opDepartment',
          colId: 'opDepartment',
          hide: true,
          width: 100,
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateOpDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.CategoryOfGoods'),
          field: 'cargoCode',
          colId: 'cargoCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
          },
          hide: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.DelegatedAssociatedBusinessStatus'),
          field: 'trustJobState',
          colId: 'trustJobState',
          hide: true,
          enableRowGroup: true,
          valueFormatter: params => {
            return ColumnUtils.getJobStateCN(Number(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.TransactionRelatedBusinessStatus'),
          field: 'relatedJobState',
          colId: 'relatedJobState',
          enableRowGroup: true,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.getJobStateCN(Number(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerContactPerson'),
          field: 'customerContact',
          colId: 'customerContact',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContactPhone'),
          field: 'telephone',
          colId: 'telephone',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContactMobile'),
          field: 'mobile',
          colId: 'mobile',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('queryJob.receivablesWriteOfStatus'),
          colId: 'verifyStateReceivable',
          field: 'verifyStateReceivable',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('queryJob.payablesWriteOfStatus'),
          colId: 'verifyStatePayable',
          field: 'verifyStatePayable',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
          field: 'receivableChargeInput',
          colId: 'receivableChargeInput',
          width: 150,
          hide: true,
          enableRowGroup: true,
          filter: false,
          filterParams: {},
          valueFormatter: params => {
            return ColumnUtils.chargeInputLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
          field: 'costChargeInput',
          colId: 'costChargeInput',
          width: 150,
          hide: true,
          filter: false,
          enableRowGroup: true,
          filterParams: {},
          valueFormatter: params => {
            return ColumnUtils.chargeInputLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
          colId: 'receivableInvoiceState',
          field: 'receivableInvoiceState',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueFormatter: params => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.AirlinePerson2'),
          colId: 'planner',
          field: 'planner',
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperatePlanner), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 80
        }, {
          headerName: this.$t('SeaExport.MasterBusinessNo'),
          colId: 'masterJobNo',
          field: 'masterJobNo',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          field: 'warehouseCmp',
          colId: 'warehouseCmp',
          enableRowGroup: true,
          valueFormatter: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_10') : ''
          },
          width: 200,
          hide: true
        }, {
          headerName: this.$t('SeaExport.TradeMethod'),
          field: 'tradeTerm',
          colId: 'tradeTerm',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TradeTerm, 'code', params.value, 'name')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLTransportationClause'),
          field: 'freightTerm',
          colId: 'freightTerm',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLTransportationClause'),
          field: 'freightTermHBL',
          colId: 'freightTermHBL',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MasterBLFreightTerm'),
          field: 'paymentTermMBL',
          colId: 'paymentTermMBL',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.paymentTermLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLFreightClause'),
          field: 'paymentTermHBL',
          colId: 'paymentTermHBL',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.paymentTermLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('common.createBy'),
          field: 'createdBy',
          hide: true,
          enableRowGroup: true,
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SopTemplateName'),
          field: 'trackingTemplateUuid',
          width: 180,
          colId: 'trackingTemplateUuid',
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TrackingTemplate, 'uuid', params.value, 'templateName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          width: 160, minWidth: 160,
          enableRowGroup: true,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          width: 200, minWidth: 200,
          enableRowGroup: true,
          hide: !this.useOrderCenterMode
        },
        { headerName: this.$t('CargoMsg.Cargo_JobProfitShare'), colId: 'jobProfitShare', field: 'jobProfitShare', width: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('queryJob.EstimatedReviewer'),
          field: 'preverifier',
          colId: 'preVerifier',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('queryJob.DateOfPreReview'),
          field: 'preverifyDate',
          colId: 'preVerifyDate',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Message.TerminalLocation'),
          colId: 'terminalCompany',
          field: 'terminalCompany',
          width: 200,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('Message.TerminalAddress'),
          colId: 'deliveryAddress',
          field: 'deliveryAddress',
          width: 200,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('SeaExport.CustomsBroker'),
          field: 'customsBroker',
          colId: 'customsBroker',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_9') : ''
          },
          width: 180
        }, {
          headerName: this.$t('SeaExport.MBLBlType'),
          field: 'mblReleaseType',
          colId: 'mblReleaseType',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.MBLBlTypeLabelFunc(TYPE_NAMES.basic_data_BlMode, Number(params.value))
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          field: 'cargoType',
          colId: 'cargoType',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          },
          hide: true,
          width: 150
        }, { headerName: this.$t('CargoMsg.Cargo_BusinessExpirationDate'), field: 'specialApprovalDate', width: 150, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Message.Customer_Service'),
          colId: 'csrDepartment',
          field: 'csrDepartment',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.data.cooperateCsrDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('Message.Documentation_Department'),
          colId: 'dcDepartment',
          field: 'dcDepartment',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.data.cooperateDcDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AirlineDepartment'),
          colId: 'plannerDepartment',
          field: 'plannerDepartment',
          width: 140,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          colId: 'mark',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: 'csrOffice',
          colId: 'csrOffice',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateCsrCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: 'dcOffice',
          colId: 'dcOffice',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateDcCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.HBLConsignee'),
          field: 'hBLConsignee',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLShipper'),
          field: 'hblShipper',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableDomestic'),
          colId: 'verifyStateReceivableDomestic',
          field: 'verifyStateReceivableDomestic',
          enableRowGroup: true,
          width: 140,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableOversea'),
          colId: 'verifyStateReceivableOversea',
          field: 'verifyStateReceivableOversea',
          enableRowGroup: true,
          width: 140,
          hide: true
        },
        { headerName: this.$t('SeaExport.BusinessLockedStatus'), field: 'businessLock', width: 100, colId: 'businessLock',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLockedStatusLabelFunc(stringToBool(params.value))
          },
          enableRowGroup: true,
          hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementType'), field: 'settlementType', width: 100, hide: true, enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'dateLimited', width: 100, hide: true, enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_IsExtended'), field: 'creditInfoDateExceeded', width: 100, hide: true, enableRowGroup: true,
          cellRenderer: params => {
            if (params.value === '') return ''
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
        },
        { headerName: this.$t('CargoMsg.Cargo_ExcessiveOrNot'), field: 'creditInfoAmountExceeded', width: 100, hide: true, enableRowGroup: true,
          cellRenderer: params => {
            if (params.value === '') return ''
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
        },
        {
          headerName: this.$t('SeaExport.AdvancePayment'),
          field: 'advancePayment',
          colId: 'advancePayment',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CustomsDutyAmount'),
          field: 'customsDutyAmount',
          colId: 'customsDutyAmount',
          enableRowGroup: true,
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('SeaExport.VatAmount'),
          field: 'vatAmount',
          colId: 'vatAmount',
          enableRowGroup: true,
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('SeaExport.PaymentTime'),
          field: 'paymentTime',
          colId: 'paymentTime',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.DateOfArrivalTheWarehouse'),
          field: 'arriveStorageDate',
          colId: 'arriveStorageDate',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
          colId: 'payableInvoiceState',
          field: 'payableInvoiceState',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.receivableInvoiceStateLabelFunction(params.data.payableInvoiceState),
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceivableFeeLockTime2'),
          colId: 'receivableChargeLockedDate',
          field: 'receivableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockTime2'),
          colId: 'payableChargeLockedDate',
          field: 'payableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockPerson'),
          colId: 'payableChargeLockedPerson',
          field: 'payableChargeLockedPerson',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.getPayableChargeLockedPerson(params.data)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InterestAmountCurrency'),
          colId: 'interestAmountCurrency',
          field: 'interestAmountCurrency',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CheckRuleResult'),
          colId: 'checkRuleResult',
          field: 'checkRuleResult',
          width: 100,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.CheckRuleResultLabelFun(params.value)
          }
        }
      ],
      columnAdds: [],
      rowData: [],
      gridApi: null,
      exportCommand: this.$t('SeaExport.ExportToExcel'),
      chargeCommand: this.$t('SeaExport.AddCharges'),
      documentManage: new DocumentManage(),
      stateDialog: {
        visible: false,
        rows: [],
        trackingList: []
      },
      shutOutDialog: {
        visible: false,
        shutOutTip1: '',
        shutOutTip2: '',
        shutOutButtonShow2: '',
        jobKeys: '',
        hasCharge: false
      },
      shutOutJobKeys: '',
      transshipDialog: {
        visible: false,
        jobKeys: [],
        bookingAgent: 0,
        carrierId: 0,
        txtBookingAgent: '',
        txtCarrierId: '',
        vessel: '',
        voyageFlight: '',
        loadingPortCode: '',
        dischargingPortCode: '',
        etd: '',
        eta: '',
        atd: '',
        ata: '',
        selectedJobs: [],
        transship: {}
      },
      chargeTypeDialog: {
        visible: false,
        selectedJobs: [],
        type: 0
      },
      fullSpellTypeDialog: {
        visible: false,
        jobKeys: [],
        jobList: [],
        containerLoadType: '',
        containerLoadTypes: ContainerLoadType.CONTAINERLOAD_TYPES_ALL_LCL
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaImportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      statisticsDialog: {
        visible: false,
        txtSlaves: 0,
        txtMaster: 0,
        txtCount: 0,
        txtCustomerCount: 0,
        txt20: 0,
        txt40: 0,
        txt40hq: 0,
        txt45: 0,
        txtTeu: 0,
        txtWeight: 0.000,
        txtChargeWeight: 0.000,
        txtCubage: 0.000,
        txtdesignationAgentNum: 0,
        containShutOutJob: false
      },
      addChargeDetailDialog: {
        visible: false,
        type: 0,
        selectedScheme: [],
        selectedJobs: []
      },
      role: {
        addReceivableChargeRole: this.$checkPermission(['button_Charge_payAddCharge']),
        addPayableChargeRole: this.$checkPermission(['button_Charge_costAddCharge'])
      },
      editChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      deleteChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      chargeSchemeBatchDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        needCheckRange: true,
        isSea: false,
        lob: 'SI',
        source: 'jobList',
        chargeType: null,
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      lob: 'SI',
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      appendQuery: false, // 追加查询
      customSearchItems: [], // 自定义查询条件
      exportOrderCommand: this.$t('SeaExport.Add'),
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      paramsBpm: [],
      opOffice: null,
      batchModifyBusinessDialog: {
        visible: false,
        jobList: [],
        jobKeys: [],
        lob: ''
      },
      changeSopTemplateDialog: {
        visible: false,
        jobList: []
      },
      batchCooperationDialog: {
        visible: false,
        jobList: []
      },
      downloadImportTemplateDialog: {
        visible: false,
        lob: 'SI'
      },
      workFlowApplyDialog: {
        visible: false
      },
      isBpmEnabled: false,
      selectedRows: [],
      defaultSearchItems: [],
      gpExplain: {
        type: 'list',
        visible: false,
        jobUuids: []
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      isZY: false,
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      clearCheckBox: {
        carrierId: false,
        bookingAgent: false,
        vessel: false,
        voyageFlight: false,
        loadingPortCode: false,
        dischargingPortCode: false,
        etd: false,
        eta: false,
        atd: false,
        ata: false
      },
      openMutualTrustConfig: false,
      instructioinBtns: [] // 指令按钮列表
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    searchItemConfigModule() {
      return '200'
    },
    finalColumnDefs() {
      let result = [...this.columnDefs, ...this.columnAdds]
      if (this.$store.state.uiCustom.enable) {
        result = UICustomUtil.handleColumnDefs(UICustomConstants.SI_BOOKING_MODULE, this.$store.getters.currentOfficeId, result)
      }
      return result
    },
    job() {
      return this.selectedJob
    },
    actionUrl() {
      return URL.seaImport.importCSVFile + '?branchId=' + this.$store.getters.currentOfficeId
    },
    // gridApi() {
    //   return this.gridOptions.api || null
    // },
    office() {
      return this.$store.getters.currentOffice || null
    },
    colorSettings() {
      return this.$store.state.settings.colorSettings
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    viewJobNoSet() {
      const openSet = new Set()
      for (const view of this.$store.state.tagsView.visitedViews) {
        if (view.path === this.$route.path && view.query && view.query.openNew && view.query.key) {
          openSet.add(view.query.key)
        }
      }
      return openSet
    },
    actionOrderUrl() {
      return URL.sys.importOrderTemplate
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return cache.config ? Number(cache.config.get('useOrderCenterMode')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return cache.config ? Number(cache.config.get('orderCenterBranch')) === 1 : false
    },
    location() {
      return LOG_SI_SEA_BOOKING.code
    },
    isHQ() {
      return this.$store.getters.currentOfficeId === 1
    },
    conditonDisplayAllBranchData() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledViewDetail() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList && !this.hqViewAllDetail
    },
    validSingleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (!this.isZy && this.hierarchyViewDetail && this.selectedJob) {
          if (this.childOfficeIds.includes(this.selectedJob.opOffice) || this.childOfficeIds.includes(this.selectedJob.salesOffice)) {
            return true
          }
        }
        if (this.selectedJob && this.selectedJob.opOffice !== this.$store.getters.currentOfficeId && this.selectedJob.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(this.selectedJob.cooperatebranch, this.$store.getters.currentOffice)) {
          return false
        }
      }
      return true
    },
    validMultipleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        for (const row of this.selectedRows) {
          if (!this.isZy && this.hierarchyViewDetail && row) {
            if (this.childOfficeIds.includes(row.opOffice) || this.childOfficeIds.includes(row.salesOffice)) {
              return true
            }
          }
          if (row.opOffice !== this.$store.getters.currentOfficeId && row.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(row.cooperatebranch, this.$store.getters.currentOffice)) {
            return false
          }
        }
      }
      return true
    }
  },
  watch: {
    colorSettings: {
      handler() {
        this.gridOptions.api.redrawRows()
      },
      deep: true
    },
    '$store.getters.currentOfficeId': {
      handler() {
        if (this.hierarchyViewList) {
          this.initCustomSearchItems()
        }
        this.loadInstructionButtons()
      }
    }
  },
  async created() {
    await this.preloadBasicData()
    await this.initColumnDefs()
    this.initCustomSearchItems()
    this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
    this.openMutualTrustConfig = Number(this.context.config.get('openMutualTrustConfig')) === 2
    this.loadInstructionButtons()
    if (this.isQuery) return
    this.queryLastModifyBookingByDay()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(context, context.workFlowApplyDialog, 'workFlowApplyDialog', documentProcessId)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async initColumnDefs() {
      // CARGO-31277 SOPSOP节点显示列增加
      const sopColumns = await SopUtil.getSopColumns('SI')
      this.columnDefs = [...this.columnDefs, ...sopColumns]
      await JobUtils.enrichTotalRevenueColumnDefs(this.columnDefs, this)
      if (this.isBpmEnabled) {
        this.columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
          field: 'documentProcessNo',
          colId: 'documentProcessNo',
          width: 200,
          hide: true,
          excelRenderer: (params) => {
            if (params.value) {
              return params.value
            }
            return ''
          },
          cellRenderer: (params) => {
            if (params.value) {
              const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
              return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.documentProcessNo ? params.data.documentProcessNo : ''
          }
        })
      }
      if (this.isZY) {
        this.columnDefs.push(
          {
            headerName: this.$t('CargoMsg.AllowSaleProduct'),
            field: 'saleProductCode',
            colId: 'saleProductCode',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.FullOrInside'),
            field: 'fullOrInside',
            colId: 'fullOrInside',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.fullOrInsideLabelFun(params.value)
            }
          }
        )
      }
    },
    // 加载指令按钮
    async loadInstructionButtons() {
      const res = await getInstructions({
        module: UICustomConstants.SI_BOOKING_MODULE,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet: true
      })
      this.instructioinBtns = res.data
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      const nodes = event.api.rowModel.rowsToDisplay
      const selectedNode = nodes[event.rowIndex]
      if (selectedNode && selectedNode.data) {
        this.manageAuditStatus = selectedNode.data.manageAuditStatus
        this.onRowClicked({ data: selectedNode.data })
      } else {
        this.onRowClicked({ data: null })
      }
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    // // 选中 勾选框触发[获取选中行]
    // onGridRowSelected(event) {
    //   if (event.node.isSelected() && event.data) {
    //     this.selectedJob = event.data
    //   }
    //   this.$logger.log('===onGridRowSelected====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
    // },
    // 选中或取消勾选触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node && node.dataType && (Number(node.dataType) === 1 || Number(node.dataType) === 2) && node.jobUuid) {
        this.selectedJob = node
        this.updateJobState()
        this.updateControlsState()
      }
    },
    // 批量操作按钮权限控制
    updateControlsState() {
      // console.log('grid', this.gridApi)
      const rows = this.gridApi.getSelectedRows()
      if (!Array.isArray(rows)) {
        return
      }
      this.btnInfo.enableBtnSplit = false
      for (const item of rows) {
        if (item.lclMasterUuid) {
          this.btnInfo.enableBtnSplit = true
          break
        }
      }
    },
    updateJobState() {
      const job = this.selectedJob
      if (job != null) {
        this.btnInfo.label.btnShutout = this.$t('SeaExport' + (job.jobState === 3 ? 'CancelShutOut' : 'ShutOut'))

        if (job && !job.masterFlag && (job.containerLoadType !== ContainerLoadType.LCL_CARGO_TYPE.code)) {
          // btnProfit.label ="整箱利润打印";
          this.btnInfo.label.btnProfit = this.$t('SeaExport.PrintFclProfit')
        } else {
          // btnProfit.label =this.$t('SeaExport.PrintLclProfit');
          this.btnInfo.label.btnProfit = this.$t('SeaExport.PrintLclProfit')
        }

        if (job && job.jobState !== 3) {
          this.btnInfo.enabled.btnProfit = this.btnInfo.privilege.button_JobBooking_Submit || this.btnInfo.privilege.button_JobBooking_PrintProfit
        } else {
          this.btnInfo.enabled.btnProfit = false
        }

        this.btnInfo.visible.btnManagerAuditSubmit = this.btnInfo.privilege.button_JobBooking_ManagerAuditSubmit && job.manageAuditStatus === 1 && (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT)
        this.btnInfo.visible.printReturn = job.jobState === SystemConstants.COMMITED && this.btnInfo.privilege.button_JobBooking_Retract
        this.btnInfo.visible.printReturnOperate = job.jobState === SystemConstants.PRE_COMMIT && this.btnInfo.privilege.button_JobBooking_ReturnToOperater
        this.btnInfo.visible.btnSubmit = (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT) && this.btnInfo.privilege.button_JobBooking_Submit && (job.manageAuditStatus === 0 || job.manageAuditStatus === 3)
        this.btnInfo.visible.btnManagerSubmit = (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT) && this.btnInfo.privilege.button_JobBooking_ManagerSubmit
        this.btnInfo.visible.btnPreSubmit = job.jobState === SystemConstants.OPERATING && this.btnInfo.privilege.button_JobBooking_PreSubmit && (job.manageAuditStatus === 0 || job.manageAuditStatus === 3)
      } else {
        this.btnInfo.visible.btnPreSubmit = false
        this.btnInfo.visible.btnSubmit = false
        this.btnInfo.visible.btnManagerSubmit = false
        this.btnInfo.visible.printReturnOperate = false
        this.btnInfo.visible.printReturn = false
      }
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      const { config } = cache
      this.ticketsMustBeVoted = Number(config.get('TicketsMustBeVoted')) === 1
      this.useCheckRule = Number(config.get('useCheckRule')) === 1
      this.allowPartialCheckPass = Number(config.get('allowPartialCheckPass')) === 1
      this.checkApChargeVerify = Number(config.get('PreCommitJobCheckApChargeStateVerify')) === 1
      this.editVessel = Number(config.get('EditVesselVoyageMode'))
      this.chargeSchemeBatchDialog.chargeSchemeIsApproved = Number(config.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才能使用【费用方案页签使用】
      this.toExoSystemYGSH = String(config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.isBpmEnabled = await WorkflowUtil.isBpmEnabled({
        documentConfigId: Job_CHARGE.code,
        officeId: this.$store.getters.currentOfficeId
      })
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy'
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    },
    // 查询[简单查询/高级查询]
    toQuery(saveJobNos, removedJobNos) {
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.toBackQuery(saveJobNos, removedJobNos)
        return
      }
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询最近几天的业务
    queryLastModifyBookingByDay() {
      const loading = getLoading4Cxt(this)
      this.context.loading = true
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.createdBy = this.$store.getters.userId
      if (this.isBpmEnabled) {
        this.filterJson.requires = ['bpm']
      }
      queryLastModifyBookingByDay(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        loading.close()
        this.context.loading = false
      })
    },
    // 高级查询
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = this.addConditionsBeforeQuery(data)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(this.filterJson.conditions)
        this.filter.pageNum = 1
      }
      if (!this.filterJson.conditions) {
        this.queryLastModifyBookingByDay()
        return
      }
      const loading = getLoading4Cxt(this)
      this.context.loading = true
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.appendQuery = this.appendQuery
      if (this.isBpmEnabled) {
        this.filterJson.requires = ['bpm']
      }
      if (this.notRefresh) {
        console.log('请等上次查询完再执行查询操作')
        return
      }
      this.notRefresh = true
      advancedQuery(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        loading.close()
        this.context.loading = false
        this.notRefresh = false
      })
    },
    // 查询之前的条件组装
    addConditionsBeforeQuery(data) {
      if (typeof data === 'undefined') return

      if (AdvancedSearchOption.hasField('cargoDocHBL.HBL_NBR2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
      }
      if (AdvancedSearchOption.hasField('cargoDoc.HBL_NBR2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDoc.DOC_TYPE', CargoDocConsts.HBL2).formatObj2Json())
      }
      if (AdvancedSearchOption.hasField('seaCargoDoc.SUB_DOC_TYPE2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDoc.DOC_TYPE', CargoDocConsts.MBL2).formatObj2Json())
      }
      // MBL 提单方式
      if (AdvancedSearchOption.hasField('cargoDocMBL.RELEASE_TYPE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocMBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocMBL.DOC_TYPE', CargoDocConsts.MBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_MBL', true).formatObj2Json())
        }
      }
      // HBL 提单方式
      if (AdvancedSearchOption.hasField('cargoDocHBL.RELEASE_TYPE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }
      // MBL 放单状态  qm
      if (AdvancedSearchOption.hasField('seaCargoDocMBL.RELEASE_TYPE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocMBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocMBL.DOC_TYPE', CargoDocConsts.MBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_MBL', true).formatObj2Json())
        }
      }
      if (!((this.$store.getters.currentOfficeId === 1 && this.hqViewAllList) || this.hierarchyViewList)) {
        const option = new AdvancedSearchOption(null, 'job.OP_OFFICE', this.$store.getters.currentOfficeId)
        data.push(option.formatObj2Json())
      }

      if (!AdvancedSearchOption.hasField('job.JOB_STATE', data)) {
        const jobStates = []
        for (const c of SystemConstants.JOB_STATES) {
          jobStates.push(c.code)
        }
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
        data.push(option.formatObj2Json())
      }

      // todo
      /* if (AdvancedSearchOption.hasField(SpecialFieldConstants.LOAD_RELATION_JOBS, conditions))
      {
        var option:AdvancedSearchOption = AdvancedSearchOption.getOption(SpecialFieldConstants.LOAD_RELATION_JOBS, conditions);
        ImportConstants.loadRelationJobsSI = option.value;
      }
      else
      {
        ImportConstants.loadRelationJobsSI = true;
      }*/

      // 如果状态追踪没有选中值则将条件移除
      if (AdvancedSearchOption.hasField('trackingInfo._multipleState_', data)) {
        const trackingInfoOption = AdvancedSearchOption.getOption('trackingInfo._multipleState_', data)
        if (trackingInfoOption) {
          const trackingInfoValue = trackingInfoOption.value.value
          if (!trackingInfoValue || (isArray(trackingInfoValue) && trackingInfoValue.length <= 0)) {
            AdvancedSearchOption.removeOption('trackingInfo._multipleState_', data)
          }
        }
      }
      return data
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.SELF_DELIVER')
        } else if (stuffyType.code === 'CT') {
          result.push('seaJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('seaJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('seaJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'AMS') {
          result.push('seaJob.AMS')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        }
      }
      return result
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      this.context.loading = true
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      if (!this.filter.jobNo) {
        // this.queryLastModifyBookingByDay()
        return
      }
      this.$logger.log('this.filter', this.filter)
      this.filter.branchId = this.$store.getters.currentOfficeId
      if (this.isBpmEnabled) {
        this.filter.requires = ['bpm']
      }
      const loading = getLoading4Cxt(this)
      findSeaImportJobByNo(this.filter).then(res => this.handleQueryData(res)).finally(() => {
        loading.close()
        this.context.loading = false
      })
    },
    // 返回查询
    toBackQuery(jobs, removedJobs) {
      setTimeout(() => {
        this.backHandleQueryData(jobs, removedJobs)
      })
    },
    backHandleQueryData(results, removedJobs) {
      let hasNew = false // 是否有新增数据
      for (const item of results) {
        const index = this.rowData.findIndex(p => p.uuid === item.uuid)
        if (index >= 0) {
          this.rowData[index] = item
        } else {
          this.rowData.push(item)
          hasNew = true
        }
      }
      for (let i = this.rowData.length - 1; i >= 0; --i) {
        if (removedJobs.findIndex(p => p.uuid === this.rowData[i].uuid) >= 0) {
          this.rowData.splice(i, 1)
        }
      }
      if (hasNew || removedJobs.length > 0) {
        /* 记录勾选项 */
        const rows = this.gridApi.getSelectedRows()
        if (rows.length > 0) {
          const keys = Array.from(rows, p => p.uuid)
          setTimeout(() => {
            const masterSelectedSet = new Set()
            const nodes = this.gridApi.rowModel.rowsToDisplay
            for (const node of nodes) {
              if (!node.data) {
                continue
              }
              if (keys.includes(node.data.uuid)) {
                node.setSelected(true)
                if (node.data.masterFlag) {
                  masterSelectedSet.add(node.data.uuid)
                }
              } else {
                if (node.data.lclMasterUuid && masterSelectedSet.has(node.data.lclMasterUuid)) {
                  setTimeout(() => {
                    node.setSelected(false)
                  })
                }
              }
            }
          }, 100)
        }
      } else {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        for (const item of results) {
          const node = nodes.find(p => p.data && p.data.uuid === item.uuid)
          node.setData(item)
        }
        // this.gridApi.resetRowHeights()
      }
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      let results = res.data.list
      // 对返回结果进行排序放在后端 getJobsBySort 方法
      // 动态添加SOP显示列[根据SOP显示列字段进行拆分]
      // const headerNameArr = []
      if (results && results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const seaJob = results[i] // 当前行
          const currentJobSopState = seaJob.sopState // 当前行的SOP数据
          if (!currentJobSopState) continue
          const tracks = currentJobSopState.split(',')
          // console.log('==========tracks===========', tracks)
          // 循环每个节点Sop数据，动态添加显示列
          for (let j = 0; j < tracks.length; j++) {
            const currentTrack = tracks[j]
            if (!currentTrack) continue
            const columnName = currentTrack.split('(')[0]
            const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
            const columnValue = !oldColumnValue ? '' : oldColumnValue
            //
            const columnField = '_sop_' + columnName
            // if (!headerNameArr.includes(columnName)) {
            //   headerNameArr.push(columnName)
            //   this.columnAdds.push({ headerName: columnName, field: columnField, width: 100, hide: true })
            // }
            results[i][columnField] = columnValue
          }
        }
      }
      if (this.appendQuery) { // 追加查询数据去重
        results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        this.total = results.length
      } else {
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
        this.pageCount = res.data.pages
      }
      this.rowData = results
      this.selectedRowCount = 0
      selectedStatus.revert()
    },
    // 查看
    async toLook(row) {
      const multipleJobViewMode = Number(cache.config.get('MultipleJobViewMode')) || 0
      const directEdit = row ? Number(cache.config.get('JobDirectEditingStatus')) === 1 : false
      if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
        const rows = row ? [row] : this.readSelectedRows()
        const jumpRows = []
        const openSet = new Set([...this.viewJobNoSet])
        for (const item of rows) {
          if (!openSet.has(item.jobNo)) {
            jumpRows.push(item)
            openSet.add(item.jobNo)
          }
        }
        if (openSet.size > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        if (jumpRows.length === 0) {
          this.$router.push({ name: 'SiBooking', query: { openNew: true, key: rows[0].jobNo }})
          return
        }
        for (const item of jumpRows) {
          const action = directEdit && item.jobState === 0 && !JobUtils.isBlockJob(item) && (await SecurityUtil.canEdit(new SeaImportJob(item))) ? 'edit' : 'look'
          setTimeout(() => {
            this.$router.push({ name: 'SiBooking', query: { openNew: true, key: item.jobNo }, params: { rowData: [...this.rowData], action }})
          }, 100)
        }
        // 切回到跳转的第一票
        setTimeout(() => {
          this.$router.push({ name: 'SiBooking', query: { openNew: true, key: jumpRows[0].jobNo }})
        }, 100)
      } else {
        if (!row) {
          row = this.selectedJob || this.readSelectedRows()[0]
        }
        if (this.viewJobNoSet.has(row.jobNo)) {
          this.$router.push({ name: 'SiBooking', query: { openNew: true, key: row.jobNo }})
        } else {
          const action = directEdit && row.jobState === 0 && !JobUtils.isBlockJob(row) && (await SecurityUtil.canEdit(new SeaImportJob(row))) ? 'edit' : 'look'
          this.$emit(action, row)
        }
      }
    },
    // 获取选中行 dataType 区分拆并单数据 业务数据，1 主票 2 小票 3 MBL 4 MBL2 5 HBL2
    readSelectedRows() {
      const allRows = this.gridApi.getModel().rowsToDisplay.filter(node => node.data && node.selected).map(node => node.data)
      const rows = []
      for (const row of allRows) {
        if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
          rows.push(row)
        }
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 编辑
    async toEdit() {
      const row = this.selectedJob || this.readSelectedRows()[0]
      if (!row) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (row.jobState !== 0) {
        this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(new SeaImportJob(row))) {
        this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      if (this.viewJobNoSet.has(row.jobNo)) {
        this.$router.push({ name: 'SiBooking', query: { openNew: true, key: row.jobNo }, params: { action: 'edit' }})
        return
      }
      const multipleJobViewMode = Number(cache.config.get('MultipleJobViewMode')) || 0
      if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
        if (this.viewJobNoSet.size + 1 > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        this.$router.push({ name: 'SiBooking', query: { openNew: true, key: row.jobNo }, params: { rowData: [...this.rowData], action: 'edit' }})
      } else {
        row.version = 0 // 以便于从数据库中加载Job数据
        this.$emit('edit', row)
      }
    },
    // 新增
    toAdd(row) {
      this.$emit('add', row || {})
    },
    // 拆分主票
    toSplit() {
      this.context.loading = false
      const rows = this.readSelectedRows()
      const jobKeys = [] // 已加入主票的小票uuids
      for (const item of rows) {
        if (item.lob === 'SE' && item.lclMasterUuid) {
          jobKeys.push(item.uuid)
        }
      }
      if (jobKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoBusinessCanBeSplit'))
        return
      }

      const params = {
        jobKeys: jobKeys,
        splitPattern: 0 // 拆分模式 0.选择小票拆分 1.按装箱信息拆分
      }
      splitMaster(params).then(res => {
        const newSplitJob = res.data
        this.$logger.log('=====newSplitJob=====', newSplitJob)
        this.$logger.log('=====newSplitJob.seaEQ=====', newSplitJob.seaEQ)
        this.$logger.log('=====newSplitJob.lclSlaves=====', newSplitJob.lclSlaves)
        if (!newSplitJob || !newSplitJob.seaEQ || newSplitJob.seaEQ.length === 0) {
          this.$message.warning(this.$t('Message.SplittingErrorContainerInformationIsEmpty'))
          return
        }
        this.$emit('split', newSplitJob)
      }).finally(() => {
        this.context.loading = false
      })
    },
    // 复制
    toCopy() {
      const usefulJob = this.selectedJob
      if (usefulJob.masterFlag) {
        this.$emit('copy', usefulJob)
      } else {
        if (usefulJob.customerId) {
          const loading = getLoading4Cxt(this)
          isContractExpiredForbidCreateJob(usefulJob.customerId).then(res => {
            if (res.data) {
              this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
            } else {
              this.$emit('copy', usefulJob)
            }
          }).finally(() => {
            loading.close()
          })
        }
      }
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (fileType !== 'csv') {
        this.$message.warning(this.$t('queryJob.UploadedOnlyBeInFormat'))
      } else {
        return true
      }
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.code === '0') {
        this.onImportSucceeded(response.data)
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message) {
        this.$message.info(this.$t('Message.Page') + message + this.$t('queryJob.ThatSOk'), this.$t('Message.ImportSuccessful1'))
      }
    },
    // 删除
    toDelete() {
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState > 0) {
          this.$message.warning(`[${item.jobNo}]${this.$t('SeaImport.NotTheCorrectOperationStatus')}`)
          return
        }
        if (this.viewJobNoSet.has(item.jobNo)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('queryJob.JobOpenedAndCannotDelete'))
          return
        }
      }
      const jobKeys = []
      for (const row of rows) {
        jobKeys.push(row.uuid)
      }
      const loading = getLoading4Cxt(this)
      this.context.loading = true
      validateJobForDelete({ keys: jobKeys }).then(res => this.handlerDelete(res)).finally(() => {
        this.context.loading = false
        loading.close()
      })
    },
    // 删除验证结果
    handlerDelete(res) {
      const delMap = res.data
      if (!delMap.canDelete) {
        if (delMap.hasDelete) {
          this.$message.warning(this.$t('CargoMsg.HasDeletedForDeleteJob'))
        }
        if (delMap.existsSlaveJob) {
          this.$message.warning(this.$t('CargoMsg.HasSlaveJobForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsCharge) {
          this.$message.warning(this.$t('CargoMsg.HasChargeForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsMergeJob) {
          this.$message.warning(this.$t('CargoMsg.HasMergeForDeleteJob', [delMap.jobNo]))
        }
        return
      }

      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      this.$confirm(this.$t('Message.SureDeleteThese') + jobKeys.length + this.$t('Message.OrdersOfBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.context.loading = true
        const loading = getLoading4Cxt(this)
        batchDeleteJob({ jobKeys, opLob: 'SI', location: this.location }).then(res => this.handlerDeleteResult(res)).finally(() => {
          loading.close()
          this.context.loading = false
        })
      })
    },
    // 删除成功处理
    handlerDeleteResult(res) {
      const result = res.data
      if (result > 0) {
        this.$message.success(this.$t('Message.DeleteSuccessfully'))
        this.selectedJob = null
        const rows = this.readSelectedRows()
        for (const row of rows) {
          const index = this.rowData.indexOf(row)
          this.rowData.splice(index, 1)
        }
        this.gridApi.refreshCells({ force: true })
      }
    },
    // 导出公共
    exportHandle() {
      const rows = this.readSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.info('未选择数据')
        return
      }
      const timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      switch (this.exportCommand) {
        case this.$t('SeaExport.ExportToExcel'):
          this.toExportToExcel()
          break
        case this.$t('SeaExport.ExportWithSOPToExcel'):
          this.toExportWithSOPToExcel()
          break
      }
    },
    // 导出Excel
    toExportToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridApi.columnController.getAllDisplayedColumns()
      // 获取选中行
      const rows = this.readSelectedRows()
      const newRows = deepClone(rows)
      this.toExport(newRows, allDisplayedColumns)
    },
    // 导出Excel(含SOP明细)
    async toExportWithSOPToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridApi.columnController.getAllDisplayedColumns()
      // 获取选中行
      const rows = this.readSelectedRows()
      // copy一个新的
      const newRows = deepClone(rows)
      if (!newRows || newRows.length <= 0) return
      const jobKeys = Array.from(newRows, p => p.uuid)
      let jobSopStates = {}
      await getJobSopStates(jobKeys).then(res => {
        jobSopStates = res.data
      })

      // 查询海运进口的所有SOP节点
      const sopTemplateMap = await SopUtil.getSopTemplateMap(newRows)
      const headerNameMap = new Map()
      const sopColumns = []
      // 循环每条业务数据
      for (let i = 0; i < newRows.length; i++) {
        const seaJob = newRows[i] // 当前行
        if (!sopTemplateMap.hasOwnProperty(seaJob.trackingTemplateUuid)) {
          continue
        }
        const trackMap = sopTemplateMap[seaJob.trackingTemplateUuid]
        const newSopState = (jobSopStates && Object.prototype.hasOwnProperty.call(jobSopStates, seaJob.uuid)) ? jobSopStates[seaJob.uuid] : ''
        const currentJobSopState = !newSopState ? seaJob.sopState : newSopState // 当前行的SOP数据

        if (!currentJobSopState) continue
        const tracks = currentJobSopState.split(',')
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          if (trackMap.hasOwnProperty(columnName)) {
            const track = trackMap[columnName]
            if (track && (Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_E.code) || Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_SUPPLEMENT.code))) {
              continue
            }
          }
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? this.$t('Message.NotStart') : oldColumnValue
          //
          if (!headerNameMap.has(columnName)) {
            headerNameMap.set(columnName, columnValue)
            sopColumns.push({ headerName: columnName, field: columnName, columnType: 'SOP' })
          }
          newRows[i][columnName] = columnName + ' ' + columnValue
        }
      }
      // 获取所有列
      const allColumns = [...allDisplayedColumns, ...sopColumns]
      this.toExport(newRows, allColumns)
    },
    toExport(rows, columns) {
      const fileName = 'SIBookingList'
      exportExcel(fileName, rows, columns)
    },
    // 修改SOP状态
    editState() {
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      let lob = null
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (lob !== null && lob !== item.lob) {
          this.$message.warning(this.$t('Message.PleaseSelectTheSameTypeOfJob'))
          return
        }
        lob = item.lob
      }
      getTrackingListByLob(lob).then(res => {
        this.stateDialog.trackingList = res.data
      })
      this.stateDialog.rows = this.readSelectedRows()
      this.stateDialog.visible = true
    },
    // 批量操作
    batchHandle(val) {
      if (val !== 3) {
        if (this.hierarchyViewList) {
          if (val !== 5) {
            const rows = this.readSelectedRows()
            this.checkOwnerBranch(rows)
          }
        }
      }
      switch (val) {
        case 1:
          this.toBatchPreSubmit()
          break
        case 2:
          this.toBatchSubmit()
          break
        case 3:
          this.toBatchManagerSubmission()
          break
        case 4:
          // 批量撤回预提交
          this.toBatchReturnSubmit(true)
          break
        case 5:
          // 批量撤回提交
          this.toBatchReturnSubmit(false)
          break
        case 6:
          // 批量解锁应收费用
          this.toBatchModifyChargeLockStatus(true)
          break
        case 7:
          // 批量解锁应付费用
          this.toBatchModifyChargeLockStatus(false)
          break
        case 8:
          // 批量锁定应收费用
          this.toBatchModifyChargeLockingStatus(true)
          break
        case 9:
          // 批量锁定应付费用
          this.toBatchModifyChargeLockingStatus(false)
          break
        case 10:
          this.toBatchUpdateCustomType()
          break
        case 17:
          this.toBatchModifyBusiness()
          break
        case 18:
          this.toBatchUpdateSopTemplate()
          break
        case 19:
          this.toBatchCooperation()
          break
        case 20:
          JobUtils.toBatchFillGpExplain(this.readSelectedRows(), this.gpExplain)
          break
        case 21:
          JobUtils.batchLockJobHandler(this, this.readSelectedRows(), true, this.toQuery)
          break
        case 22:
          JobUtils.batchLockJobHandler(this, this.readSelectedRows(), false, this.toQuery)
          break
        case 23:
          this.toShutOut()
          break
        case 24:
          this.toBatchSyncChargeConfirm()
          break
        case 27:
          this.toBatchTransship()
          break
        case 28:
          JobUtils.batchReturnReview(this, this.readSelectedRows())
          break
      }
      if (typeof val === 'string') {
        if (val.startsWith('instruction,')) {
          const tenantInstructionUuid = val.split(',')[1]
          const item = this.instructioinBtns.find(item => item.tenantInstructionUuid === tenantInstructionUuid)
          if (item) {
            if (item.platformInstructionRuleCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code) {
              if (!this.$store.getters.isGroupCompany) {
                this.$message.warning(this.$t('SystemMaintenance.NonNotSupportCrossTenants'))
                return
              }
              this.$refs.tenantEntrustWindow.onShowOfUI(item, this.readSelectedRows())
            }
          }
        }
      }
    },
    onInstructionCallback(data) {
      this.loadInstructionButtons()
      if (data.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code) {
        this.toQuery()
      }
    },
    // 批量推送费用(交叉委托)
    toBatchSyncChargeConfirm() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const j of rows) {
        jobKeys.push(j.uuid)
      }
      this.loading = getLoading()
      syncChargeConfirmBatch(jobKeys).then(res => {
        this.$message.success(this.$t('queryJob.GenerateXChargeSyncRecords', { num: res.data }))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 退关
    toShutOut() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.OPERATING)) {
          this.$message.info(this.$t('Message.IsNotOperationStatusCannotBeShutOut'))
          return
        }
        // 财务审核
        if (item.jobState === 2) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenSubmittedCannotBeShutOut'))
          return
        }
        // 退关
        if (item.shutOut) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenShutOuted'))
          return
        }
        jobKeys.push(item.uuid)
      }
      this.shutOutJobKeys = jobKeys
      canBatchShutout({ jobKeys }).then(res => this.canBatchShutoutResult(res))
    },
    // 验证退关
    canBatchShutoutResult(res) {
      const result = Number(res.data)
      if (result === 0) {
        this.$confirm(this.$t('Message.SureShutOutAndDeleteCharge'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(async() => {
          const loading = getLoading4Cxt(this)
          try {
            await this.shutoutHandler().then(res => this.batchShutoutResult(res))
          } finally {
            loading.close()
          }
        }).catch(() => { })
      } else if (result === 1) {
        this.$message.info(this.$t('Message.IfDoNotClearTheConfirmationFeeDoNotAllowFreeShutOut'))
      } else if (result === 2) {
        this.$message.info(this.$t('Message.PleaseRemoveThisTicketFromMblThenShutOutBatch'))
      } else if (result === 3) {
        this.$message.info(this.$t('Message.PleaseRemoveAllTicketsFromMblThenShutOutBatch'))
      }
    },
    // 退关公共
    async shutoutHandler() {
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      batchShutout({ jobKeys, hasCharge: false, location: this.location }).then(res => this.batchShutoutResult(res))
    },
    // 退关处理结果
    batchShutoutResult(res) {
      const list = res.data
      const len = list == null ? 0 : list.length
      this.$message.success(this.$t('Message.ShutOutSuccessfully') + ': ' + len)

      if (len === 0) return
      const objJobKey = {}
      const jobKeys = this.shutOutJobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          seaJob.shutOut = true
          seaJob.jobState = SystemConstants.SHUT_OUT
        }
      }
      this.refreshAgGrid()
    },
    // 批量预提交
    toBatchPreSubmit() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const j of rows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (Number(j.jobState) !== Number(SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('Message.BulkSubmissionOfWrittenPreSubmissionsOnlyList'))
          return
        }
        if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
          this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
          return
        }
        jobKeys.push(j.uuid)
      }
      this.context.loading = true
      const loading = getLoading4Cxt(this)
      // 检查应付费用是否全部审核
      checkChargeStateVerify(jobKeys).then(res => this.checkChargeStateVerifyResult(res)).then(() => {
        loading.close()
        this.context.loading = false
      })
    },
    // 检查应付费用是否全部审核
    async checkChargeStateVerifyResult(res) {
      const result = res.data
      if (this.checkApChargeVerify && result === 0) {
        this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
        return
      }
      const officeId = this.$store.getters.currentOfficeId
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      if (jobKeys.length > 0) {
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_PRE_COMMIT.code
        const opOffice = (rows && rows.length > 0) ? rows[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          if (this.allowPartialCheckPass) {
            const callBack = this.batchPreCommitCall || null
            this.checkingManagerJobs(rows, checkNode, callBack, null, true)
          } else {
            const callBack = this.batchPreCommitCall || null
            this.checkingManagerJobs(rows, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesPreSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            const loading = getLoading4Cxt(this)
            this.context.loading = true
            batchPreCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerPreCommitResult(res)).then(() => {
              loading.close()
              this.context.loading = false
            })
          }).catch(() => {
          })
        }
      }
    },
    // 批量预提交回调
    batchPreCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
        this.$logger.log('预提交——jobKeys：', jobKeys)
      }
      if (jobKeys && jobKeys.length > 0) {
        this.context.loading = true
        const loading = getLoading4Cxt(this)
        const officeId = this.$store.getters.currentOfficeId
        batchPreCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerPreCommitResult(res)).then(() => {
          this.context.loading = false
          loading.close()
        })
      }
    },
    // 批量预提交处理结果
    handlerPreCommitResult(res) {
      const list = res.data
      const len = (list === null || list === '') ? 0 : list.length
      this.$message.success(this.$t('Message.BatchSubmittedPreSuccessfully') + ': ' + len)
      this.toQuery()
    },
    // 批量提交
    async toBatchSubmit() {
      const rows = this.readSelectedRows()
      let jobKeys = []
      let selectedJobs = []
      const allowBatchSubmitJobState = cache.config.get('AllowBatchSubmitJobState')
      const allowBatchSubmitJobStateArr = allowBatchSubmitJobState ? allowBatchSubmitJobState.split(',') : []
      const operateStr = SystemConstants.OPERATING.toString()
      const preCommitStr = SystemConstants.PRE_COMMIT.toString()
      const len = allowBatchSubmitJobStateArr.length
      const paramsBpm = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (len > 1 && allowBatchSubmitJobStateArr.includes(operateStr) && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.OPERATING || Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchSubmitCheck'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(operateStr) && !(Number(item.jobState) === SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckOperate'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckPre'))
          return
        }
        if (!item.masterFlag && (item.lclMasterUuid === null || item.lclMasterUuid === '') && (item.containerLoadType === 'LCL' || item.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
          this.$message.info(this.$t('Message.TicketsMustBeVoted'))
          return
        }
        jobKeys.push(item.uuid)
        selectedJobs.push(item)
        // 构建bpm请求参数
        const paramBpm = {
          documentConfigId: Job_CHARGE.code,
          docId: item.uuid,
          docNo: item.jobNo,
          actionType: 7000,
          officeId: item.opOffice,
          applicationDimension: APPLICATION_DIMENSION_JOB_CHARGE.code
        }
        paramsBpm.push(paramBpm)
      }

      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            selectedJobs = []
            for (const item of rows) {
              if (jobKeys.indexOf(item.uuid) !== -1) {
                selectedJobs.push(item)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_COMMIT.code
        const opOffice = (selectedJobs && selectedJobs.length > 0) ? selectedJobs[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = selectedJobs // 回调中使用
          this.paramsBpm = paramsBpm
          this.opOffice = selectedJobs[0].opOffice
          if (this.allowPartialCheckPass) {
            const callBack = this.batchCommitCall || null
            this.checkingManagerJobs(selectedJobs, checkNode, callBack, null, true)
          } else {
            const callBack = this.batchCommitCall || null
            this.checkingManagerJobs(selectedJobs, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('queryJob.AreTicketsSubmitted'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(async() => {
            if (await WorkflowUtil.isBpmEnabled({
              documentConfigId: Job_CHARGE.code,
              officeId: selectedJobs[0].opOffice
            })) {
              WorkflowUtil.jobBatchCommitBpm(this, paramsBpm)
              return
            }
            this.context.loading = true
            const loading = getLoading4Cxt(this)
            const officeId = this.$store.getters.currentOfficeId
            batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res)).finally(() => {
              this.context.loading = false
              loading.close()
            })
          }).catch(() => {
          })
        }
      }
    },
    // 批量提交回调
    async batchCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        this.$logger.log('提交——jobKeys：', jobKeys)
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        // 过滤有效keys
        this.paramsBpm = this.paramsBpm.filter(paramBpm => jobKeys.indexOf(paramBpm.docId) !== -1)
        if (await WorkflowUtil.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: this.opOffice })) {
          WorkflowUtil.jobBatchCommitBpm(this, this.paramsBpm)
          return
        }
        const officeId = this.$store.getters.currentOfficeId
        this.context.loading = true
        const loading = getLoading4Cxt(this)
        batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res)).then(() => {
          this.context.loading = false
          loading.close()
        })
      }
    },
    // Lts同步
    batchLtsSyncHandle(val) {
      const rows = this.readSelectedRows(true)
      if (!rows || rows.length <= 0) return
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      this.$refs.ltsBatchSyncCharge.onShow({ rows: rows, anyBool: val })
      this.ltsWindow.visible = true
    },
    // 批量提交处理结果
    handlerCommitResult(res) {
      const list = res.data
      const len = (list === null || list === '') ? 0 : list.length
      this.$message.success(this.$t('Message.BatchSubmittedSuccessfully') + ': ' + len)
      this.toQuery()
    },
    // 批量转船
    toBatchTransship() {
      const rows = this.readSelectedRows()
      if (rows.length <= 0) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      // 检查小票是否都勾选了对应的主票
      const selectedMasterUuids = rows.filter(row => row.masterFlag).map(row => row.uuid)
      const hasUnselectedMaster = rows.some(row => {
        // 如果是小票（非主票）且有主票关联
        if (!row.masterFlag && row.lclMasterUuid) {
          // 检查该小票对应的主票是否被选中
          return !selectedMasterUuids.includes(row.lclMasterUuid)
        }
        return false
      })

      if (hasUnselectedMaster) {
        this.$message.info(this.$t('Message.PleaseSelectTheMainTicketForModification'))
        return
      }

      // 初始化弹窗数据
      this.toInitTransshipDialog()
      for (const item of rows) {
        // 判断业务状态是否为“正操作”，若是不是，则提示：仅支持批量修改正操作业务
        if (Number(item.jobState) === Number(SystemConstants.OPERATING) && !JobUtils.isBlockJob(item)) {
          this.transshipDialog.jobKeys.push(item.uuid)
          this.transshipDialog.selectedJobs.push(item)
        } else {
          this.$message.info(this.$t('Message.SelectTransshipmentStatusErrorPrompt'))
          return
        }
      }

      // 显示弹窗
      this.transshipDialog.visible = true
    },
    // 批量转船点击确定
    transShipClickHandler() {
      const jobs = this.transshipDialog.selectedJobs
      if (jobs == null || jobs.length === 0) {
        return
      }
      const obj = {}
      obj.jobKeys = this.transshipDialog.jobKeys
      if (this.transshipDialog.vessel !== '') {
        obj.vessel = this.transshipDialog.vessel
      }
      if (this.transshipDialog.voyageFlight !== '') {
        obj.voyageFlight = this.transshipDialog.voyageFlight
      }
      const carrierId = this.transshipDialog.txtCarrierId
      if (carrierId !== '' && carrierId > 0) {
        obj.carrierId = carrierId
      }
      if (this.transshipDialog.etd !== '') {
        obj.etd = this.transshipDialog.etd
      }
      if (this.transshipDialog.eta !== '') {
        obj.eta = this.transshipDialog.eta
      }
      if (this.transshipDialog.atd !== '') {
        obj.atd = this.transshipDialog.atd
      }
      if (this.transshipDialog.ata !== '') {
        obj.ata = this.transshipDialog.ata
      }
      const bookingAgent = this.transshipDialog.txtBookingAgent
      if (bookingAgent !== '' && bookingAgent > 0) {
        obj.bookingAgent = bookingAgent
      }
      if (this.transshipDialog.dischargingPortCode) {
        obj.dischargingPortCode = this.transshipDialog.dischargingPortCode
        obj.dischargingPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', obj.dischargingPortCode, 'englishName')
      }
      if (this.transshipDialog.loadingPortCode) {
        obj.loadingPortCode = this.transshipDialog.loadingPortCode
        obj.loadingPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', obj.loadingPortCode, 'englishName')
      }

      obj.clearCheckBox = this.clearCheckBox
      this.transshipDialog.transship = obj
      this.loading = getLoading()
      batchTransship(obj).then(res => this.batchTransshipResult(res)).finally(() => {
        this.loading.close()
      })
    },
    // 初始化 批量转船对话框数据
    toInitTransshipDialog() {
      this.transshipDialog.selectedJobs = []
      this.transshipDialog.vessel = ''
      this.transshipDialog.voyageFlight = ''
      this.transshipDialog.txtCarrierId = ''
      this.transshipDialog.etd = ''
      this.transshipDialog.eta = ''
      this.transshipDialog.atd = ''
      this.transshipDialog.ata = ''
      this.transshipDialog.loadingPortCode = ''
      this.transshipDialog.dischargingPortCode = ''
      this.transshipDialog.txtBookingAgent = ''
      this.transshipDialog.jobKeys = []
      this.transshipDialog.transship = {}
      this.clearCheckBox.carrierId = false
      this.clearCheckBox.bookingAgent = false
      this.clearCheckBox.vessel = false
      this.clearCheckBox.voyageFlight = false
      this.clearCheckBox.loadingPortCode = false
      this.clearCheckBox.dischargingPortCode = false
      this.clearCheckBox.etd = false
      this.clearCheckBox.eta = false
      this.clearCheckBox.atd = false
      this.clearCheckBox.ata = false
    },
    // 批量转船 处理返回结果
    batchTransshipResult(res) {
      // const list = res.data
      this.$confirm(this.$t('Message.BulkTransshipmentSuccessWhetherYouWantToCloseThePopUpWindow'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'success'
      }).then(() => {
        this.batchTransshipFresh()
        this.transshipDialog.visible = false
      }).catch(() => {
        this.batchTransshipFresh()
      })
    },
    // 批量转船 刷新
    batchTransshipFresh() {
      const objJobKey = {}
      const jobKeys = this.transshipDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      const transship = this.transshipDialog.transship
      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          if (transship.hasOwnProperty('vessel')) {
            seaJob.vessel = transship.vessel
          }
          if (transship.hasOwnProperty('voyage')) {
            seaJob.voyageFlight = transship.voyage
          }
          if (transship.hasOwnProperty('carrierId')) {
            seaJob.carrierId = transship.carrierId
          }
          if (transship.hasOwnProperty('etd')) {
            seaJob.etd = transship.etd
          }
          if (transship.hasOwnProperty('bookingAgent')) {
            seaJob.bookingAgent = transship.bookingAgent
          }
        }
      }
      this.gridApi.refreshCells({ force: true })
    },
    // 批量修改整拼类型
    toFullSpellType() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      const jobList = []
      for (const j of rows) {
        if (j.containerLoadType !== ContainerLoadType.LCL_CARGO_TYPE.code && j.containerLoadType !== ContainerLoadType.BC_CARGO_TYPE.code && j.containerLoadType !== ContainerLoadType.BB_CARGO_TYPE.code) {
          this.$message.info(this.$t(j.jobNo + '该票业务整拼类型不是自拼箱、buyer consol、委托拼箱'))
          return
        }
        if (j.jobState !== SystemConstants.STATE_OPERATING.code) {
          this.$message.info(this.$t(j.jobNo + this.$t('SeaExport.RecordNotPositiveOperationStatus')))
          return
        }
        if (j.masterFlag) {
          this.$message.info(this.$t(j.jobNo + this.$t('SeaExport.TheTicketIsMain')))
          return
        }
        if (j.lclMasterUuid !== null && j.lclMasterUuid !== '') {
          this.$message.info(this.$t(j.jobNo + this.$t('SeaExport.TheTicketAssociatedMain')))
          return
        }
        jobKeys.push(j.uuid)
        jobList.push(j)
      }
      this.fullSpellTypeDialog.jobKeys = jobKeys
      this.fullSpellTypeDialog.jobList = jobList
      this.context.loading = true
      const loading = getLoading4Cxt(this)
      checkJobHasContainer(jobKeys).then(res => this.checkJobHasContainerResult(res)).finally(() => {
        this.context.loading = false
        loading.close()
      })
    },
    // 验证是否装箱
    checkJobHasContainerResult(res) {
      const jobKey = res.data
      if (jobKey !== '' && jobKey !== null) {
        for (const job of this.fullSpellTypeDialog.jobList) {
          if (job.uuid === jobKey) {
            this.$message.info(this.$t(job.jobNo + this.$t('SeaExport.TheTicketAssociatedContainerInfo')))
            return
          }
        }
        return
      }
      this.fullSpellTypeDialog.visible = true
    },
    // 批量修改整拼类型点击确定
    fullSpellTypeClickHandler() {
      const containerLoadType = this.fullSpellTypeDialog.containerLoadType
      const jobs = this.fullSpellTypeDialog.jobList
      if (jobs != null && jobs.length > 0) {
        for (const job of jobs) {
          if (job.containerLoadType === containerLoadType) {
            this.$message.info(this.$t(job.jobNo + this.$t('SeaExport.ContainerLoadTypeIs') + SeaExportConstants.getTypeName(containerLoadType) + this.$t('SeaExport.NoneModified')))
            return
          }
        }

        const obj = {}
        obj.jobKeys = this.fullSpellTypeDialog.jobKeys
        obj.type = containerLoadType
        this.context.loading = true
        const loading = getLoading4Cxt(this)
        updateJobContainerLoadType(obj).then(res => this.updateJobContainerLoadTypeResult(res)).finally(() => {
          this.context.loading = true
          loading.close()
        })
      }
    },
    // 批量修改整拼类型 处理结果
    updateJobContainerLoadTypeResult(res) {
      const r = res.data
      if (r.result === 1) {
        this.updateJobContainerLoadTypeFresh()
        this.$message.success(this.$t(this.$t('SeaExport.ContainerLoadTypeBatchModifySuccess') + r.num))
      } else {
        this.$message.info(this.$t(this.$t('SeaExport.NoDataProcessed')))
      }
      this.fullSpellTypeDialog.visible = false
      this.fullSpellTypeDialog.containerLoadType = ''
      this.fullSpellTypeDialog.jobKeys = []
      this.fullSpellTypeDialog.jobList = []
    },
    // 批量修改整拼类型 刷新数据
    updateJobContainerLoadTypeFresh() {
      const objJobKey = {}
      const jobKeys = this.fullSpellTypeDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          seaJob.containerLoadType = this.fullSpellTypeDialog.containerLoadType
        }
      }
      this.gridApi.refreshCells({ force: true })
    },
    // 统计
    async toStatistics() {
      this.statisticsClean()
      const loading = getLoading4Cxt(this)
      try {
        await this.handleStatistics()
        this.statisticsDialog.visible = true
      } finally {
        loading.close()
      }
    },
    async handleStatistics(isChangeContainShutOutJob = false) {
      let rows = this.gridApi.getSelectedRows().filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1 || Number(p.dataType) === 2))
      if (rows.length === 0) {
        rows = this.rowData.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1 || Number(p.dataType) === 2))
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      const jobKeys = []
      const designationAgents = []
      const customers = []
      let weight = 0
      let chargeWeight = 0
      let cubage = 0
      let slavesCount = 0
      let masterCount = 0
      let count = 0
      let lob = ''
      // 列表勾选的数据是否都为”已退关“
      let allJobShutOut = true
      for (const job of rows) {
        if (!job.shutOut) {
          allJobShutOut = false
          break
        }
      }
      for (const job of rows) {
        if (job.shutOut) {
          // 弹窗手动修改”是否包含退关“
          if (isChangeContainShutOutJob && !this.statisticsDialog.containShutOutJob) {
            continue
          } else if (!isChangeContainShutOutJob && !allJobShutOut) { // 第一次打开弹窗
            continue
          }
        }
        count++
        if (lob === '') lob = job.lob
        jobKeys.push(job.uuid)
        if (job.masterFlag) {
          masterCount += 1
        } else {
          weight += isNaN(job.weightContract) ? 0 : job.weightContract
          cubage += isNaN(job.cubageContract) ? 0 : job.cubageContract
          chargeWeight += isNaN(job.chargeWeight) ? 0 : job.chargeWeight
          slavesCount += 1
        }
        if (!customers.includes(job.customerId) && !job.masterFlag) {
          customers.push(job.customerId)
        }
        if (!designationAgents.includes(job.designationAgent) && job.designationAgent !== 0) {
          designationAgents.push(job.designationAgent)
        }
      }
      this.statisticsDialog.txtSlaves = slavesCount.toString()
      this.statisticsDialog.txtMaster = masterCount.toString()
      this.statisticsDialog.txtCount = count.toString()
      this.statisticsDialog.txtCustomerCount = customers.length.toString()
      this.statisticsDialog.txtWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(weight), 2)
      this.statisticsDialog.txtCubage = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(cubage), 2)
      this.statisticsDialog.txtChargeWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(chargeWeight), 2)
      this.statisticsDialog.txtdesignationAgentNum = designationAgents.length.toString()
      if (!isChangeContainShutOutJob && allJobShutOut) {
        this.statisticsDialog.containShutOutJob = true
      }
      await statisticsJobs({ jobKeys: jobKeys, lob: 'SI', containShutOutJob: this.statisticsDialog.containShutOutJo }).then(res => {
        this.statisticsJobsResult(res)
      })
    },
    // 统计结果
    statisticsJobsResult(res) {
      this.statisticsDialog.txt20 = res.data.b20
      this.statisticsDialog.txt40 = res.data.b40
      this.statisticsDialog.txt40hq = res.data.b40h
      this.statisticsDialog.txt45 = res.data.b45
      this.statisticsDialog.txtTeu = res.data.teu
    },
    // 统计完成 清空对象
    statisticsClean() {
      this.statisticsDialog.txtSlaves = ''
      this.statisticsDialog.txtMaster = ''
      this.statisticsDialog.txtCount = ''
      this.statisticsDialog.txtCustomerCount = ''
      this.statisticsDialog.txt20 = ''
      this.statisticsDialog.txt40 = ''
      this.statisticsDialog.txt40hq = ''
      this.statisticsDialog.txt45 = ''
      this.statisticsDialog.txtTeu = ''
      this.statisticsDialog.txtWeight = ''
      this.statisticsDialog.txtChargeWeight = ''
      this.statisticsDialog.txtCubage = ''
      this.statisticsDialog.txtdesignationAgentNum = ''
      this.statisticsDialog.containShutOutJob = false
    },
    // 批量预提交
    async batchPreCommitHandler() {
      const selectedJobs = this.readSelectedRows()
      const keys = []
      // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      const ticketsMustBeVoted = parseInt(cache.config.get('TicketsMustBeVoted'))
      const checkApChargeVerify = parseInt(cache.config.get('PreCommitJobCheckApChargeStateVerify'))
      // SeaImportJob
      for (const job of selectedJobs) {
        if (checkApChargeVerify === 1) {
          const isPass = await JobUtils.checkChargeStateVerify(this.job)
          if (!isPass) {
            this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
            return
          }
        }
        if (job.jobState !== SystemConstants.OPERATING) {
          this.$message.info(this.$t('Message.BulkSubmissionOfWrittenPreSubmissionsOnlyList'))
          return
        }
        if (!job.masterFlag && !job.lclMasterUuid && (job.containerLoadType === 'LCL' || job.containerLoadType === 'BC') && ticketsMustBeVoted === 1) {
          this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
          return
        }
        keys.push(job.uuid)
      }

      if (keys.length > 0) {
        this.context.loading = true
        const self = this
        const officeId = this.$store.getters.currentOfficeId
        // 判断是否开启验证规则
        const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
        const checkNode = CheckRuleConstants.NODE_PRE_COMMIT.code
        const opOffice = (selectedJobs && selectedJobs.length > 0) ? selectedJobs[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (useCheckRule && hasCheckRule) {
          this.checkingManagerJobs(selectedJobs, checkNode, () => {
            const loading = getLoading4Cxt(this)
            batchPreCommit({ jobKeys: keys, officeId: officeId, location: this.location }).then(res => self.handlerPreCommitResult(res)).catch(e => self.faultHandler).finally(() => {
              this.context.loading = false
              loading.close()
            })
          })
        } else {
          await this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + ' ' + keys.length + this.$t('queryJob.IsTheTicketPreSubmitted'))
          const loading = getLoading4Cxt(this)
          batchPreCommit({ jobKeys: keys, officeId: officeId, location: this.location }).then(res => self.handlerPreCommitResult(res)).catch(e => self.faultHandler).finally(() => {
            this.context.loading = false
            loading.close()
          })
        }
      }
    },
    // /**
    //  * 批量验证
    //  */
    // multiChecking(checkNode, jobs, callBack) {
    //   this.batchCheckingWindow.checkNode = checkNode
    //   this.batchCheckingWindow.jobs = jobs
    //   this.batchCheckingWindow.callBack = callBack
    //   this.batchCheckingWindow.visible = true
    // },

    // 批量处理费用
    chargeHandle() {
      if (this.hierarchyViewList) {
        const rows = this.readSelectedRows()
        this.checkOwnerBranch(rows)
      }
      switch (this.chargeCommand) {
        case this.$t('SeaExport.AddCharges'):
          this.toAddCharge()
          break
        case this.$t('SeaExport.EditCharges'):
          this.toEditCharge()
          break
        case this.$t('SeaExport.DeleteCharges'):
          this.toDeleteCharge()
          break
        case this.$t('SeaExport.ChargeImport'):
          this.toImportCharge()
          break
      }
    },
    // 新增费用
    async toAddCharge() {
      const selectedJobs = []
      const jobs = this.readSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      // if (!await this.validateChargeLocked(jobs)) return
      // this.addChargeDetailDialog.selectedJobs = selectedJobs
      // this.addChargeDetailDialog.visible = true
      this.chargeTypeDialog.type = this.role.addPayableChargeRole ? 2 : 1
      this.chargeTypeDialog.selectedJobs = selectedJobs
      this.chargeTypeDialog.visible = true
    },
    onChargeTypeDialogConfirm() {
      this.chargeTypeDialog.visible = false
      // 应收是否锁定
      const type = this.chargeTypeDialog.type
      const rows = this.chargeTypeDialog.selectedJobs
      if (!rows || rows.length === 0) return
      if (type === 0) {
        const chargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0 && p.payableChargeLockedStatus > 0)
        if (chargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ARAP_Locked'))
          return
        }
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      } else if (type === 1) {
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
      } else if (type === 2) {
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      }

      if (this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        if (type === 0 || type === 2) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AR'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && this.role.addPayableChargeRole) {
        if (type === 0 || type === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AP'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Cannot_Add_Charge'))
        return
      }

      if (!JobUtils.checkJobCustomerIdIfSame(this.arSettlementUnitOptional, type, rows, this)) {
        return
      }
      this.addChargeDetailDialog.selectedJobs = rows
      this.addChargeDetailDialog.type = type
      this.addChargeDetailDialog.selectedScheme = []
      this.addChargeDetailDialog.visible = true
    },
    // 编辑费用
    async toEditCharge() {
      const selectedJobs = []
      const jobs = this.readSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoBusinessOrIsNotOperationalState'))
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      this.editChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.editChargeDetailDialog.selectedJobs = selectedJobs
      this.editChargeDetailDialog.visible = true
    },
    // 删除费用 todo 待优化，两个接口可以合并成一个接口
    async toDeleteCharge() {
      const selectedJobs = []
      const jobKeys = []
      const jobs = this.gridApi.getSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          jobKeys.push(obj.uuid)
          selectedJobs.push(obj)
        }
      }
      if (jobKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      this.deleteChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.deleteChargeDetailDialog.selectedJobs = selectedJobs
      this.deleteChargeDetailDialog.visible = true
    },
    // 删除费用处理结果
    batchCheckRemoveChargeResult(res) {
      const canDeleteChargeKeys = res.data
      if (canDeleteChargeKeys && canDeleteChargeKeys.length > 0) {
        this.context.loading = true
        const loading = getLoading4Cxt(this)
        batchRemoveCharge(canDeleteChargeKeys, this.location).then(res => {
          if (res.data > 0) {
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
          } else {
            this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
          }
        }).finally(() => {
          this.context.loading = false
          loading.close()
        })
      } else {
        this.$message.warning(this.$t('Message.NoCostToRemove'))
      }
    },
    // 批量导入费用
    async toImportCharge() {
      const selectedJobs = []
      const jobs = this.readSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          if (!obj.masterFlag) {
            selectedJobs.push(obj)
          }
        } else {
          this.$message.warning(this.$t('Message.AllDataMustBeOperating'))
          return
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (selectedJobs.length > 500) {
        this.$message.info(this.$t('Message.TheNumberOfSelectedDataLimited') + 500)
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      // 将相同的委托单位、订舱代理、承运人、整拼类型、货物类型、起运港、目的港、目的港代理带入到费用方案窗口
      let isSameCustomer = true
      let isSameBookingAgent = true
      let isSameCarrierId = true
      const isSameContainerLoadType = true
      let isSameCargoType = true
      let isSameLoadingPort = true
      let isSameDestinationPort = true
      let isSameDestinationAgent = true
      let isSameVesselLine = true
      const containerLoadType = selectedJobs[0].containerLoadType
      const customerId = selectedJobs[0].customerId
      const bookingAgent = selectedJobs[0].bookingAgent
      const carrierId = selectedJobs[0].carrierId
      const cargoType = selectedJobs[0].cargoType
      const loadingPort = selectedJobs[0].loadingPortCode
      const destinationPort = selectedJobs[0].destinationPortCode
      const destinationAgent = selectedJobs[0].destinationAgent
      let vesselLine = ''
      const port = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', selectedJobs[0].dischargingPortCode)
      if (port) {
        vesselLine = port.region
      }
      for (const seaJob of selectedJobs) {
        if (!this.addChargeDetailDialog.visible) {
          if (seaJob.containerLoadType !== containerLoadType) {
            this.$message.info(this.$t('Message.TheSelectedDocumentInconsistentNatureOfTheContainerLoadType'))
            return
          }
        }
        if (customerId !== seaJob.customerId) {
          isSameCustomer = false
        }
        if (bookingAgent !== seaJob.bookingAgent) {
          isSameBookingAgent = false
        }
        if (carrierId !== seaJob.carrierId) {
          isSameCarrierId = false
        }
        if (containerLoadType !== seaJob.containerLoadType) {
          isSameCargoType = false
        }
        if (cargoType !== seaJob.cargoType) {
          isSameCargoType = false
        }
        if (loadingPort !== seaJob.loadingPortCode) {
          isSameLoadingPort = false
        }
        if (destinationPort !== seaJob.destinationPortCode) {
          isSameDestinationPort = false
        }
        if (destinationAgent !== seaJob.destinationAgent) {
          isSameDestinationAgent = false
        }
        const seaPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', seaJob.dischargingPortCode)
        if (vesselLine !== (seaPort ? seaPort.region : '')) {
          isSameVesselLine = false
        }
      }
      var sameCondition = {}
      if (isSameCustomer) {
        sameCondition['customerId'] = customerId
      }
      if (isSameBookingAgent) {
        sameCondition['bookingAgent'] = bookingAgent
      }
      if (isSameCarrierId) {
        sameCondition['carrierId'] = carrierId
      }
      if (isSameContainerLoadType) {
        sameCondition['containerLoadType'] = containerLoadType
      }
      if (isSameCargoType) {
        sameCondition['cargoType'] = cargoType
      }
      if (isSameLoadingPort) {
        sameCondition['loadingPort'] = loadingPort
      }
      if (isSameDestinationPort) {
        sameCondition['destinationPort'] = destinationPort
      }
      if (isSameDestinationAgent) {
        sameCondition['destinationAgent'] = destinationAgent
      }
      if (isSameVesselLine) {
        sameCondition['vesselLine'] = vesselLine
      }
      this.chargeSchemeBatchDialog.source = this.addChargeDetailDialog.visible ? 'addCharge' : 'jobList'
      this.chargeSchemeBatchDialog.chargeType = this.addChargeDetailDialog.visible ? this.chargeTypeDialog.type : null
      this.chargeSchemeBatchDialog.selectedJobs = selectedJobs
      this.chargeSchemeBatchDialog.job = this.selectedJob ? this.selectedJob : selectedJobs[0]
      this.chargeSchemeBatchDialog.needCheckRange = !(selectedJobs.length > 1) // 勾选了多票业务就不要用单个业务数据区间过滤费用方案
      this.chargeSchemeBatchDialog.isSea = true
      this.chargeSchemeBatchDialog.lob = 'SI'
      this.chargeSchemeBatchDialog.originalCondition = sameCondition
      this.chargeSchemeBatchDialog.visible = true
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      // TemplateSelectorWin.getInstance().showThisWin(data as AbstractEntity, "JOB_DETAIL_OP", {"JOB_UUID":data.key}, FlexGlobals.topLevelApplication as DisplayObject);
      if (!this.selectedJob) return
      this.templateSelectorDialog.ctx = new SeaImportJob(this.selectedJob)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 批量打印
    onBatchPrint(command) {
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      const jobKeys = Array.from(rows, p => p.uuid)
      if (jobKeys.length > 0) {
        // TemplateSelectorWin.getInstance().showThisWin(_job, "JOBLIST", {"JOB_UUID":uids,"LOB":_job.lob}, _view);
        this.templateSelectorDialog.ctx = new SeaImportJob().fillDefaultValue().getData()
        this.templateSelectorDialog.category = 'SIJOBLIST'
        this.templateSelectorDialog.data = {
          'JOB_UUID': jobKeys,
          'LOB': 'SI',
          'printSource': DocumentConstants.BATCH_PRINT_SI.code
        }
        // 是否按照多个打印
        if (command === this.$t('queryJob.PrintByBusinessNumber')) {
          Object.assign(this.templateSelectorDialog.data, {
            'JOB_UUID': jobKeys[0],
            multiplePrint: true,
            multipleJobUuid: jobKeys
          })
        }
        this.templateSelectorDialog.visible = true
      }
    },
    //  验证规则配置公用
    checkingManagerJobs(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.visible = true
      }
    },
    // 选中父级自动勾选子集，取消选中类似
    treeDataRowSelectedCallBack(p) {
      // return
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    },
    // 预提交
    doSubmitPrint_PreSubmit() {
      if (this.isCooperate(this.job.cooperateStatus)) {
        this.$message.warning('[' + this.job.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
        return
      }
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_PRE_COMMIT.code)
    },
    // 提交
    doSubmitPrint_Submit() {
      if (this.isCooperate(this.job.cooperateStatus)) {
        this.$message.warning('[' + this.job.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
        return
      }
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_COMMIT.code)
    },
    // 主管提交
    doSubmitPrint_ManagerSubmit() {
      if (this.isCooperate(this.job.cooperateStatus)) {
        this.$message.warning('[' + this.job.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
        return
      }
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_MANAGER_COMMIT.code)
    },
    // 主管审核
    async doSubmitAudit_ManagerSubmit() {
      const job = this.job
      const checkApChargeVerify = parseInt(cache.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (checkApChargeVerify === 1) {
        const isPass = await JobUtils.checkChargeStateVerify(this.job)
        if (!isPass) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
      }
      // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      const ticketsMustBeVoted = parseInt(cache.config.get('TicketsMustBeVoted'))
      if (!job.masterFlag && !job.lclMasterUuid && (job.containerLoadType === 'LCL' || job.containerLoadType === 'BC') && ticketsMustBeVoted === 1) {
        this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
        return
      }
      const callBack = this.getDoSubmitAudit_ManagerSubmit || null
      const callBack2 = this.getDoSubmitAudit_ManagerSubmit2 || null
      const checkNode = 10
      this.checkingManager(checkNode, callBack, callBack2)
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit() {
      commit(this.job.uuid, SystemConstants.OPERATE_SUBMISSION.code, false, this.office.officeId, this.location).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
      })
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit2() {
      this.commonInfo.showMessage = false
      this.loadChargesPrintReturnHandler()
    },
    // 主管审核【验证规则回调函数】
    async loadChargesPrintReturnHandler() {
      this.context.loading = true
      const loading = getLoading4Cxt(this)
      const job = await getSeaImportJobByUuid(this.job.uuid).then(res => res.data ? res.data : null)
      if (job) Object.assign(this.job, job)
      const charges = await new SeaImportJob(this.job).getCharges()
      this.refChargeChargeState(charges)
      this.job.jobState = SystemConstants.OPERATING
      this.job.manageAuditStatus = 0
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      await saveJobInfo(this.job).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
        if (this.commonInfo.showMessage) {
          this.$message.info(this.$t('Message.AlreadyWithdraw'))
        } else {
          this.commonInfo.showMessage = true
        }
      })
      loading.close()
      this.context.loading = false
    },
    // node 提交 检测的节点【预提交/提交/主管提交】
    async doSubmitPrintPROFIT(node) {
      const job = await getSeaImportJobByUuid(this.job.uuid).then(res => res.data ? res.data : null)
      this.commonInfo.allSubmitFcl = Number(cache.config.get('AllSubmitFcl')) === 1
      this.commonInfo.isPreCommit = node === CheckRuleConstants.NODE_PRE_COMMIT.code
      this.commonInfo.needSend = false
      // sap 交单验证结算公司
      this.commonInfo.openSapConfig = Number(cache.config.get('openSapConfig')) === 1
      if (this.commonInfo.openSapConfig) {
        job.charges = await new SeaImportJob(this.job).getCharges()
        for (const charge of job.charges) {
          if (charge.settleDepartmentPrefix === '' || charge.settleDepartmentPrefix == null) {
            const n = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId, 'chineseName')
            this.$message.info(n + this.$t('Message.escnm'))
            return
          }
        }
      }
      if (node === CheckRuleConstants.NODE_PRE_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_PRE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_COMMIT.code) {
        this.commonInfo.needSend = true
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
        this.commonInfo.needSend = true
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_MANAGER_SUBMISSION.code
      }

      this.commonInfo.isPrintOpr = false
      const checkApChargeVerify = Number(cache.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (this.commonInfo.isPreCommit && checkApChargeVerify === 1) {
        const isPass = await JobUtils.checkChargeStateVerify(this.job)
        if (!isPass) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
      }
      // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      const ticketsMustBeVoted = Number(cache.config.get('TicketsMustBeVoted'))
      if (!job.masterFlag && !job.lclMasterUuid && (job.containerLoadType === 'LCL' || job.containerLoadType === 'BC') && ticketsMustBeVoted === 1) {
        this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
        return
      }
      // 判断是否开启验证规则
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      const opOffice = this.job.opOffice || 0
      // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, node, opOffice)
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        const callBack = this.getDoSubmitPrintPROFIT || null
        const callBack2 = this.commitResultHandler || null
        const checkNode = node
        this.checkingManager(checkNode, callBack, callBack2)
      } else {
        if (this.commonInfo.allSubmitFcl) {
          this.doSubmitAllFcl()
        } else {
          this.doSubmitPrint()
        }
      }
    },
    // 提交【验证规则回调函数】
    async getDoSubmitPrintPROFIT() {
      const job = this.job
      const checkChargeInvoice = Number(cache.config.get('CheckReceivableChargePrintInvoice'))
      if (this.commonInfo.isPreCommit || checkChargeInvoice < 1) {
        const self = this
        commit(job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPreCommit, this.$store.getters.currentOfficeId, this.location).then(res => {
          self.selectedJob = res.data
          self.$message.success(this.$t('Message.CommitSuccessfully'))
          self.commitResultHandler(res)
        })
      } else {
        getChargeIsInvoice(job.uuid).then(res => this.getChargeIsInvoiceResult(res))
      }

      // 列表重新加载
      this.toQuery()
    },
    // 提交【验证规则回调函数】
    async commitResultHandler(res) {
      const job = this.selectedJob
      if (this.commonInfo.openSapConfig && this.commonInfo.needSend) {
        const jobs = []
        jobs.push(this.selectedJob.uuid)
        if (job.masterFlag && job.lclSlaves) {
          for (const j of job.lclSlaves) {
            jobs.push(j.uuid)
          }
        }
        const params = {}
        params.jobKey = jobs
        params.oldSapStatus = ChargeUtils.CHARGE_US.code
        params.sapStatus = ChargeUtils.CHARGE_SH.code
        params.needUpdateCharge = true
        const self = this
        sendSapMessageByJob(params).then(res => {
          self.$message.success(self.$t('Message.SapSynchronizationSuccess'))
          self.refreshHandler()
        })
      } else {
        this.refreshHandler()
      }
      // 列表重新加载
      this.toQuery()
    },
    // 提交主票，小票一起提交
    async doSubmitAllFcl() {
      if (this.job.lclMasterUuid) {
        this.$message.warning(this.$t('Message.LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL'))
        return
      } else if (this.job.masterFlag) {
        await this.getLclSlavesAndCharges()
        this.loadSubmitAllFclHandler()
      } else {
        this.doSubmitPrint()
      }
    },
    // 根据主票加载小票以及小票费用
    async getLclSlavesAndCharges() {
      await new SeaImportJob(this.job).getCharges()
      const lclSlaves = await new SeaImportJob(this.job).getLclSlaves()
      if (lclSlaves) {
        for (const lclJob of lclSlaves) {
          if (lclJob.uuid && !lclJob.charges) {
            await new SeaImportJob(lclJob).getCharges()
          }
        }
      }
    },
    // 提交主票
    async loadSubmitAllFclHandler() {
      this.context.loading = true
      const loading = getLoading4Cxt(this)
      const job = await getSeaImportJobByUuid(this.job.uuid).then(res => res.data ? res.data : null)
      if (job) Object.assign(this.job, job)
      await RateUtil.refreshChargeRatesByJob(this.job)
      this.job.jobState = this.commonInfo.isPreCommit ? SystemConstants.PRE_COMMIT : SystemConstants.COMMITED
      for (const c of this.job.charges) {
        c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
      }
      for (const lclJob of this.job.lclSlaves) {
        lclJob.jobState = this.commonInfo.isPreCommit ? SystemConstants.PRE_COMMIT : SystemConstants.COMMITED
        if (!this.commonInfo.isPreCommit) {
          for (const c of lclJob.charges) {
            c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
          }
        }
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      if (this.job.jobState === SystemConstants.PRE_COMMIT) {
        if (!this.job.charges) {
          this.job.charges = await new SeaImportJob(this.job).getCharges()
        }
        await saveJobInfo(this.job).then(async res => {
          await this.mergeCurrentRow(res)
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          await this.refresh()
        })
      } else {
        // 保存刷新过的的汇率 by Marco 2014-8-8 (Bad Design)
        this.resetNoNeedSaveData()
        await saveJobInfo(this.job).then(async res => {
          await this.mergeCurrentRow(res)
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          this.commonInfo.isPrint = false
          if (this.btnInfo.visible.printFclProfit) {
            this.checkPrintEnable(this.doPrintFCLPROFIT)
          } else {
            this.checkPrintEnable(this.doPrintLCLPROFIT)
          }
        })
      }
      loading.close()
      this.context.loading = false
    },
    // 整箱利润打印提交
    doPrintFCLPROFIT() {
      calculateProfit(this.job.uuid, -1, this.commonInfo.isPrintOpr, this.commonInfo.allSubmitFcl, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.previewFCLProfit(res))
    },
    // 拼箱利润打印提交
    doPrintLCLPROFIT() {
      calculateProfit(this.job.uuid, -1, this.commonInfo.isPrintOpr, this.commonInfo.allSubmitFcl, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.previewLCLProfit(res))
    },
    // 拼箱利润打印预处理
    previewLCLProfit(res) {
      this.previewProfit(res, 'LCL')
    },
    // 整箱利润打印预处理
    previewFCLProfit(res) {
      this.previewProfit(res, 'FCL')
    },
    // 预览打印【区分整箱拼箱】
    async previewProfit(res, type) {
      await this.mergeCurrentRow(res)
      // TemplateSelectorWin.getInstance().showThisWin(this.job, "LCLPROFIT", params, this, null, this.doPrintPROFIT, this.doPrintPROFIT_V2)
      // TemplateSelectorWin.getInstance().showThisWin(this.job, "FCLPROFIT", params, this, null, this.doPrintPROFIT, this.doPrintPROFIT_V2)
      this.$nextTick(() => {
        const params = {}
        params.jobuuid = this.job.uuid
        params.showPreview = this.commonInfo.isPrint
        params.JOB_UUID = this.job.uuid
        // 提交之前需要预打印，预打印是不需要弹出提示框的，这里主要是控制PrintTemplateManager.profitSubmitHandler的提示控制
        let category = 'PXLR_SI'
        if (type === 'FCL') {
          params.isCommitJob = this.commonInfo.isPrint
          category = 'SIFCLPROFIT'
        }
        params.isPreCommit = this.commonInfo.isPreCommit
        console.log(type + '-previewProfit--params--', params)
        this.templateSelectorDialog.ctx = new SeaImportJob(this.job)
        this.templateSelectorDialog.category = category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = null
        this.printedCallback = this.doPrintPROFIT
        this.v2CheckCallback = this.doPrintPROFIT_V2
        this.templateSelectorDialog.visible = true
      })
      this.updateControlsState()
      this.refresh()
    },
    // 打印回调函数
    doPrintPROFIT(event) {
      this.commonInfo.printEvent = event
      this.commonInfo.isPreCommit = event.isPreCommit
      if (PrintUtils.isExecutor(event.action)) {
        if (this.job && this.job.uuid) {
          // 检查是否有收费用未开发票
          if (this.job.jobState === SystemConstants.OPERATING) {
            getChargeIsInvoice(this.job.uuid).then(res => this.getChargeIsInvoiceResult(res))
          } else {
            this.printAlert()
          }
        }
      }
    },
    // 打印回调函数
    doPrintPROFIT_V2(isSure, template, entity, arms) {
      if (isSure && arms) {
        this.commonInfo.isPreCommit = arms.event.isPreCommit
        if (PrintUtils.isExecutor(arms.event.action)) {
          this.printAlert()
        }
      }
    },
    // 确认是否可打印
    checkPrintEnable(callback) {
      if (this.job && !this.job.masterFlag && this.job.sales <= 0 && this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        const msg = this.commonInfo.isPrint ? this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndPrints')) : this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndSubmit'))
        this.$message.info(msg)
        return
      }
      const jobNos = this.checkSales()
      if (jobNos.length > 0) {
        const msg1 = this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + ':\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndPrint')
        const msg2 = this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + ':\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndSubmit')
        this.$message.info(this.commonInfo.isPrint ? msg1 : msg2)
        return
      }
      callback()
    },
    // 验证销售及揽货类型
    async checkSales() {
      const jobNos = []
      if (this.job.masterFlag) {
        const lclSlaves = await new SeaImportJob(this.job).getLclSlaves()
        if (!lclSlaves) {
          for (const j of this.job.lclSlaves) {
            if (j.sales <= 0 && j.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
              jobNos.push(j.jobNo)
            }
          }
        }
      }
      return jobNos
    },
    // 正常提交
    async doSubmitPrint() {
      const job = await getSeaImportJobByUuid(this.job.uuid).then(res => res.data ? res.data : null)
      if (job) Object.assign(this.job, job)
      if (this.job.jobState === SystemConstants.PRE_COMMIT) {
        if (this.job.uuid && !this.job.charges) {
          await new SeaImportJob(this.job).getCharges()
        }
        await this.loadChargeHandler()
        return
      }
      this.commonInfo.isPrint = false
      if (!this.job.masterFlag && this.job.containerLoadType !== 'LCL') {
        this.checkPrintEnable(this.doPrintFCLPROFIT)
      } else {
        this.checkPrintEnable(this.doPrintLCLPROFIT)
      }
    },
    // 加载当前业务的费用
    async loadChargeHandler() {
      this.job.jobState = SystemConstants.COMMITED
      for (const c of this.job.charges) {
        if (c.chargeState === BillingConstants.CHARGE_STATE_NORMAL.code) {
          c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
        }
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.job.submissionDate = DateUtils.formatStandardDateTime(new Date())
      this.job.commitUser = this.$store.getters.userId
      await saveJobInfo(this.job).then(async res => {
        await this.commitResultHandler()
        await this.mergeCurrentRow(res)
        this.$message.success(this.$t('Message.CommitSuccessfully'))
        this.refresh()
      })
    },
    // 打印回调函数
    commitRefuseHandler() {
      this.refresh()
    },
    // 检查是否有收费用未开发票
    async getChargeIsInvoiceResult(res) {
      const flag = res.data
      if (flag) {
        const msg = this.commonInfo.isPrint ? this.$t('Message.ThereAreFeesReceivableNotInvoicedPrint') : this.$t('Message.ThereAreFeesReceivableNotInvoicedSubmit')
        await this.$confirm(msg, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          await this.printAlert()
        }).catch(() => {
          this.commonInfo.isPrint = true
        })
      } else {
        await this.printAlert()
      }
    },
    // 打印提示
    async printAlert() {
      let msg = this.$t('Message.VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
      if (this.commonInfo.isPreCommit) {
        msg = this.$t('Message.SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
      }
      await this.$confirm(msg, this.$t('common.tips.warning'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.onConfirmedPrintProfit()
      }).catch({})
    },
    // 提交/预提交
    onConfirmedPrintProfit() {
      if (Number(cache.config.get('useCheckRule')) === 1) {
        printProfit(this.job.uuid, this.commonInfo.operateNameCode, this.office.officeId, '', this.location).then(res => this.calculateProfit2ResultHandler(res))
      } else {
        calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.calculateProfit2ResultHandler(res))
      }
    },
    // 提交成功
    async calculateProfit2ResultHandler(res) {
      await this.mergeCurrentRow(res)
      if (this.commonInfo.printEvent && !PrintUtils.isPrint(this.commonInfo.printEvent.action)) {
        const template = this.commonInfo.printEvent.template
        const parameter = this.commonInfo.printEvent.parameter
        let documentType = null
        if (template && template.documentTypeUuid || !Object.prototype.hasOwnProperty.call(parameter, 'documentType') || !parameter.documentType) {
          await getDocumentType(template.documentTypeUuid).then(res => {
            documentType = res.data ? res.data : null
          })
        }
        if (StimulSoftUtil.isOpenStiReport(template)) {
          parameter.designMode = this.$checkPermission(['role_template_design']) ? 1 : 0
          parameter.documentType = documentType
          await StimulSoftUtil.stiReportPreview(template, this.job, parameter)
        } else {
          const action = this.commonInfo.printEvent.action || ''
          const format = this.commonInfo.printEvent.format || ''
          const url = await PrintTemplateManager.print(template, documentType, format, parameter, action === PrintUtils.PRINT)
          if (url) {
            await this.loadMailURL(url, parameter)
          }
        }
      }
      this.updateJobState()
      this.refresh()
    },
    // 加载MailURLRequest
    async loadMailURL(url, parameter) {
      let status = -1
      const request = new XMLHttpRequest()
      request.open('GET', url, false) // false 同步，默认异步【此处需要同步，需要拿status判断做后续处理】
      request.onload = function(e) {
        status = e.target.status
      }
      request.onerror = function(e) {
        this.loadError()
      }
      request.send()
      if (Object.prototype.hasOwnProperty.call(parameter, 'showPreview') && parameter.showPreview) {
        this.httpResultEmail(status)
      }
    },
    // Mail异常结果处理
    httpResultEmail(status) {
      // 附件过大
      if (status === 0) {
        this.$message.error('附件内容过大')
      } else if (status === 1) {
        this.$message.error(this.$t('SeaExport.SmtpServerError'))
      } else if (status === 2) {
        this.$message.error(this.$t('SeaExport.NotConnectSmtpServer'))
      } else if (status === 3) {
        this.$message.error(this.$t('SeaExport.NotFindFile'))
      } else if (status === 4) {
        this.$message.error(this.$t('SeaExport.SendFileError'))
      } else if (status === 5) {
        this.$message.error(this.$t('SeaExport.AttachTemplateError'))
      } else if (status === 200) {
        this.$message.success(this.$t('SeaExport.MailSentSuccess'))
      }
    },
    // 验证规则配置公用
    async checkingManager(checkNode, callBack, callBack2) {
      this.$logger.log('this.job', this.job)
      if (!this.job) return
      let checkType = true
      if (this.job.masterFlag) {
        const lclSlaves = await new SeaImportJob(this.job).getLclSlaves()
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = [this.job, ... lclSlaves]
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.visible = true
      }
    },
    // 合并当前job【刷新当前job】
    mergeCurrentRow(res) {
      if (res && res.data) {
        Object.assign(this.selectedJob, res.data)
        this.selectedJob.uuid = res.data.uuid
        this.selectedJob.isCompleteRow = false
        this.isRefresh = true
      }
      // 重新查询list 避免再次操作时 提示未选中
      this.toQuery()
    },
    // 刷新
    refreshHandler() {
      this.selectedJob.isCompleteRow = false
      this.selectedJob.isPrint = true
      this.selectedJob.isPrintOpr = false
      this.refresh()
      this.updateJobState()
    },
    async refresh() {
      if (this.selectedJob) {
        this.selectedJob = await getJobByUuid(this.selectedJob.uuid).then(res => {
          this.showCustomerLevel()
          return res.data
        })
        this.replaceRowDataJobAndRefreshGrid(this.selectedJob)
      }
    },
    resetNoNeedSaveData() {
      if (Object.prototype.hasOwnProperty.call(this.selectedJob, 'containerUsages')) {
        for (const usage of this.selectedJob.containerUsages) {
          delete usage.container
        }
      }
      if (Object.prototype.hasOwnProperty.call(this.selectedJob, 'containers')) {
        for (const container of this.selectedJob.containers) {
          delete container.containerUsages
        }
      }
    },
    // 客户级别,合约状态
    showCustomerLevel() {
      if (this.job.lclMaster) {
        if (this.job.lclMaster.lclSlaves) {
          const lcls = this.job.lclMaster.lclSlaves
          if (lcls.length > 0) {
            for (const ljob of lcls) {
              if (ljob) {
                if (ljob.customerId > 0 || !StrUtils.isEmpty(ljob.contractStatus)) {
                  this.showCustomerLevelHander(ljob.customerId)
                }
              }
            }
          }
        }
      } else {
        this.showCustomerLevelHander(this.job.customerId)
      }
    },
    /**
     * 客户级别
     */
    showCustomerLevelHander(customerId) {
      const company = Company.getCompanyById(customerId)
      if (company != null) {
        // 客户级别
        this.loadCustomerTypeHandler(customerId)
        // 合同状态
        this.loadContractsHandler(customerId)
      }
    },

    // 客户级别
    async loadCustomerTypeHandler(customerId) {
      const company = Company.getCompanyById(customerId)
      if (company && company.customerDetail) {
        const customerType = await getCustomerTypeList({ typeId: company.customerDetail.customerTypeId }).then(res => {
          return res.data.list.length > 0 ? res.data.list[0] : null
        })
        if (customerType != null) {
          if (this.job.lclMaster) {
            const lcls = this.job.lclMaster.lclSlaves
            if (lcls && lcls.length > 0) {
              for (const ljob of lcls) {
                if (customerId === ljob.customerId && ljob.customerTypeId < 0) {
                  ljob.customerTypeId = customerType.typeId
                  break
                }
              }
            }
          } else {
            this.job.customerTypeId = customerType.typeId
          }
        }
      }
    },

    // 合约状态
    loadContractsHandler(customerId) {
      const company = Company.getCompanyById(customerId)
      const contracts = company.contracts

      if (this.job.lclMaster) {
        const lcls = this.job.lclMaster.lclSlaves
        if (lcls && lcls.length > 0) {
          for (const ljob of lcls) {
            if (customerId === ljob.customerId && StrUtils.isEmpty(ljob.contractStatus)) {
              ljob.contractStatus = this.contractsCommon(contracts)
              break
            }
          }
        }
      } else {
        this.job.contractStatus = this.contractsCommon(contracts)
      }
    },

    /**
     * 合约状态(common)
     */
    contractsCommon(contracts) {
      let strStatus = ''
      if (contracts == null || contracts.length === 0) {
        strStatus = this.$t('CargoMsg.Cargo_NotContracted')
      } else {
        const timeFcl = new Date()
        let flagFcl
        for (const contractFcl of contracts) {
          if (timeFcl >= contractFcl.beginDate && timeFcl <= contractFcl.endDate) {
            flagFcl = true
            break
          }
        }
        strStatus = flagFcl ? this.$t('CargoMsg.Cargo_Contracted') : this.$t('CargoMsg.Cargo_ContractExpired')
      }
      return strStatus
    },
    // 撤回
    async backReturn(pre) {
      if (this.isCooperate(this.job.cooperateStatus)) {
        this.$message.warning('[' + this.job.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
        return
      }
      if (!await JobUtils.backCheckJobState([this.job.uuid], pre ? SystemConstants.OPERATE_RETURN_ACTION.code : SystemConstants.OPERATE_PRINT_RETURN.code)) {
        this.toQuery()
        this.selectedJob = null
        this.updateJobState()
        return
      }
      this.$confirm(this.$t('SeaImport.AreWantToWithdrawBill'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (this.job.jobState === SystemConstants.COMMITED || this.job.jobState === SystemConstants.PRE_COMMIT) {
          this.commonInfo.operateNameCode = SystemConstants.OPERATE_PRINT_RETURN.code
          if (this.job.jobState === SystemConstants.PRE_COMMIT) {
            this.commonInfo.operateNameCode = SystemConstants.OPERATE_RETURN_ACTION.code
          }
          if (this.commonInfo.operateNameCode === SystemConstants.OPERATE_PRINT_RETURN.code) {
            this.commonInfo.returnSend = true
          }
          this.loadChargesHandler()
        }
      }).catch(() => { })
    },
    async loadChargesHandler() {
      const job = await getSeaImportJobByUuid(this.job.uuid).then(res => res.data ? res.data : null)
      if (job) Object.assign(this.job, job)
      await this.getLclSlavesAndCharges()
      if (this.job.charges) {
        this.refChargeChargeState(this.job.charges)
      }
      if (this.job.masterFlag && this.job.lclSlaves) {
        for (const lclSlave of this.job.lclSlaves) {
          if (lclSlave.charges) {
            this.refChargeChargeState(lclSlave.charges)
          }
        }
      }
      this.job.jobState = SystemConstants.OPERATING
      this.job.isShutOut = false
      this.job.manageAuditStatus = 0
      this.job.preCommitDate = null
      this.job.preCommitUser = 0
      this.job.submissionDate = null
      this.job.commitUser = 0
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      const self = this
      await saveJobInfo(this.job).then(async res => {
        self.backResultHandler()
        self.replaceRowDataJobAndRefreshGrid(res.data)
        // 重新查询list
        this.toQuery()
      })
    },
    backResultHandler() {
      const submitChargeState = Number(cache.config.get('CommitJobChangedChargeState'))
      if (this.commonInfo.openSapConfig && this.commonInfo.returnSend && submitChargeState) {
        const jobs = []
        jobs.push(this.selectedJob.uuid)
        if (this.job.masterFlag && this.job.lclSlaves) {
          for (const j of this.job.lclSlaves) {
            jobs.push(j.uuid)
          }
        }
        const params = {}
        params.jobKey = jobs
        params.oldSapStatus = ChargeUtils.CHARGE_SH.code
        params.sapStatus = ChargeUtils.CHARGE_NULL.code
        params.needUpdateCharge = true
        const self = this
        sendSapMessageByJob(params).then(res => {
          self.$message.success(self.$t('Message.SapSynchronizationSuccess'))
          self.saveChargeSapEventHandler(res)
          self.refreshHandler()
        })
      } else {
        if (this.commonInfo.showMessage) {
          this.$message.success(this.$t('Message.AlreadyWithdraw'))
        } else {
          this.commonInfo.showMessage = true
        }
        // 更新按钮
        this.updateJobState()
      }
    },
    // sap提交成功
    saveChargeSapEventHandler(res) {
      if (res.data) {
        if (res.data > 0) {
          this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        } else {
          this.$message.error(this.$t('Message.SapSynchronizationFault'))
        }
      }
      // 更新按钮
      this.updateJobState()
      this.refresh()
    },
    refChargeChargeState(charges) {
      const submitChargeState = parseInt(cache.config.get('CommitJobChangedChargeState'))
      if (submitChargeState === 1 && charges && charges.length > 0) {
        for (const c of charges) {
          if (c.chargeState === BillingConstants.CHARGE_STATE_SUBMIT.code) {
            c.chargeState = BillingConstants.CHARGE_STATE_NORMAL.code
          }
        }
      }
    },
    // 替换rowData中对应的job 并刷新列表
    replaceRowDataJobAndRefreshGrid(job) {
      if (!job) return
      const index = this.rowData.findIndex(row => row.uuid === job.uuid)
      if (index >= 0) {
        const rowNode = this.gridOptions.api.getRowNode(index)
        rowNode.setData(job)
      }
    },
    initCustomSearchItems() {
      this.customSearchItems = []
      let releaseTypes = []
      releaseTypes.push({ serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') })
      releaseTypes.push({ serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') })
      releaseTypes.push({ serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') })
      const cacheList = getFilterCacheList(basicCacheKeys.basic_data_BlMode, (item) => {
        return item.blType === BlModeType.HBL.code
      })
      if (cacheList && cacheList.length > 0) {
        releaseTypes = releaseTypes.concat(cacheList)
      }
      let searchField = new AdvancedSearchField()
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_HBL_RELEASETYPE'
      searchField.multiple = 1
      searchField.itemLabel = 'SeaExport.HBLBlType'
      searchField.itemName = 'cargoDoc.HBL_RELEASE_TYPE'
      searchField.itemValue = []
      searchField.defaultValue = []
      searchField.fields = ['name']
      searchField.tagName = 'name'
      searchField.tagValue = 'serialNumber'
      searchField.dataProvider = releaseTypes
      searchField.dataCacheKey = 'basic_data_BlMode'
      this.customSearchItems.push(searchField.formatObj2Json())
      if (this.useOrderCenterMode && this.orderCenterBranch) {
        // 协作分公司
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ' && p.code !== this.$store.getters.currentOffice.code).sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1) // 其他分公司
        offices.forEach(row => { row.code = row.officeId }) // ID
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        this.customSearchItems.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        this.customSearchItems.push(searchField.formatObj2Json())
        // 协作任务创建时间
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.subType = 'range'
        searchField.defaultConditionVal = ''
        searchField.itemName = 'cooperate.DATE_CREATED'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateCreatedDate'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        this.customSearchItems.push(searchField.formatObj2Json())
      }
      // 委托单位
      searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'customer',
        'tagValue': 'cmpIdx',
        'useSales': true,
        'includeAllOffice': this.conditonDisplayAllBranchData
      }
      searchField.itemCondition = [
        {
          'code': '=',
          'chineseName': '等于',
          'englishName': 'Equal',
          'children': null,
          'selected': false
        }, {
          'code': '!=',
          'chineseName': '不等于',
          'englishName': 'Unequal',
          'children': null,
          'selected': false
        }, {
          'code': 'IN',
          'chineseName': '包含',
          'englishName': 'In',
          'children': null,
          'selected': false
        }, {
          'code': 'NOT IN',
          'chineseName': '不包含',
          'englishName': 'Not_In',
          'children': null,
          'selected': false
        }]
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'SeaExport.ConsignationCompany'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
      const billReleases = BillReleaseType.BILL_RELEASES.map(item => {
        return { code: item.serialNumber, chineseName: item.name, englishName: item.name }
      })
      const mblBillReleases = [...billReleases]
      const blModeList = getCacheListByKey(basicCacheKeys.basic_data_BlMode)
      if (blModeList && blModeList.length > 0) {
        for (const blMode of blModeList) {
          if (blMode.blType === 1) {
            mblBillReleases.push({
              code: blMode.serialNumber,
              chineseName: blMode.localName,
              englishName: blMode.localName
            })
          }
        }
      }
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cargoDocMBL.RELEASE_TYPE'
      searchField.itemLabel = 'SeaExport.MBLBlType'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = mblBillReleases
      this.customSearchItems.push(searchField.formatObj2Json())

      // 退关（增减条件默认不展示，与海出「是否订舱打印」同类）
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.multiple = 0
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = OPERATOR_EQUAL.code
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemName = 'job.SHUT_OUT'
      searchField.itemLabel = 'SeaExport.ShutOut'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      searchField.lock = false
      searchField.defaultValue = ''
      this.customSearchItems.push(searchField.formatObj2Json())

      if (this.isBpmEnabled) {
        // CARGO-39771 BPM各审批流增加快捷入口（增加审批流水号）
        searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'approvalForm.DOCUMENT_PROCESS_NO'
        searchField.itemLabel = 'CargoMsg.Cargo_ApprovalSerialNumber'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = false
        searchField.defaultValue = ''
        searchField.action = AdvancedSearchField.ADD_ACTION
        this.customSearchItems.push(searchField.formatObj2Json())
      }

      for (const item of this.defaultSearchItems) {
        if (item.itemName === 'job.CUSTOMER_ID' && item.fieldType === 'FIELD_CUSTOMER') {
          continue
        }
        if (item.itemType === 'userSea' || item.itemType === 'user' || item.itemType === 'user2') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.officeId = ''
          }
          this.customSearchItems.push(newItem)
        } else if (item.itemType === 'company' || item.itemType === 'office' || item.itemType === 'department5') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.includeAllOffice = true
          }
          this.customSearchItems.push(newItem)
        }
      }
      // 中邮-可售卖产品和国内国外
      if (this.isZY) {
        const saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
          return mapping.statusEnabled === true && mapping.seaImportEnabled === true
        })
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        this.customSearchItems.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        this.customSearchItems.push(searchField.formatObj2Json())
      }
      if (this.hierarchyViewList) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, this.customSearchItems)
      }
      if (this.$store.state.uiCustom.enable) {
        UICustomUtil.handleSearchItems(UICustomConstants.SI_BOOKING_MODULE, this.defaultSearchItems, this.customSearchItems)
      }
    },
    // 验证费用锁定状态
    async validateChargeLocked(jobs) {
      if (jobs && jobs.length > 0) {
        let pass = true
        const keys = []
        for (const item of jobs) {
          if (item.uuid) {
            keys.push(item.uuid)
          }
        }
        await validateChargeLockStatus(keys).then(res => {
          pass = res.data
        }).catch()
        if (!pass) {
          this.$message.warning(this.$t('SeaExport.ChargeLocked'))
          return false
        }
      }
      return true
    },
    // 批量主管提交
    async toBatchManagerSubmission() {
      const selectedRows = this.readSelectedRows()
      let rows = []
      let jobKeys = []
      for (const j of selectedRows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!this.allowPartialCheckPass) {
          if (Number(j.jobState) !== Number(SystemConstants.OPERATING) && Number(j.jobState) !== Number(SystemConstants.PRE_COMMIT)) {
            this.$message.warning(this.$t('SeaExport.BatchManagerSubmissionTips'))
            return
          }
          if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
            this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
            return
          }
        }
        jobKeys.push(j.uuid)
        rows.push(j)
      }
      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            rows = []
            for (const j of selectedRows) {
              if (jobKeys.indexOf(j.uuid) !== -1) {
                rows.push(j)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_MANAGER_COMMIT.code
        const opOffice = (rows && rows.length > 0) ? rows[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          const callBack = this.batchBatchManagerSubmissionCall || null
          this.checkingManagerJobs(rows, checkNode, callBack, null, this.allowPartialCheckPass)
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesManagerSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchManagerCommit({ jobKeys: jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerBatchManagerSubmissionResult(res))
          }).catch(() => {
          })
        }
      }
    },
    batchBatchManagerSubmissionCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        batchManagerCommit({ jobKeys: jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerBatchManagerSubmissionResult(res))
      }
    },
    // 批量主管提交处理结果
    handlerBatchManagerSubmissionResult(res) {
      const len = res.data ? res.data.length : 0
      this.$message.success(this.$t('SeaExport.BatchManagerSubmissionSuccessfully') + len)
      this.toQuery()
    },
    // 批量撤回预提交/提交
    async toBatchReturnSubmit(pre) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new SeaImportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (pre) {
          if (item.jobState !== Number(SystemConstants.PRE_COMMIT)) {
            this.$message.warning(this.$t('Message.BatchReturnPreSubmitCheck'))
            return
          }
        } else {
          if (item.jobState !== Number(SystemConstants.COMMITED)) {
            this.$message.warning(this.$t('Message.BatchReturnSubmitCheck'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, pre ? SystemConstants.OPERATE_RETURN_ACTION.code : SystemConstants.OPERATE_PRINT_RETURN.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        const t = pre ? this.$t('Message.Return') : this.$t('Message.Withdraw')
        this.$confirm(this.$t('Message.IsConfirm') + t + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'SI', location: this.location }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.BatchReturnSucceeded', [res.data.length]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量解锁应收/应付费用
    async toBatchModifyChargeLockStatus(receivable) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new SeaImportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.UnlockChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 0 }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullyUnlockedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量锁定应收/应付费用
    async toBatchModifyChargeLockingStatus(receivable) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new SeaImportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.LockingChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 1 }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullylockingedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 导出导入订单模板
    exportOrderHandle() {
      switch (this.exportOrderCommand) {
        case this.$t('SeaExport.Add'):
          this.toAdd()
          break
        case this.$t('SeaExport.import'):
          this.$refs.uploadOrder.submit()
          break
        case this.$t('CargoMsg.Cargo_DownImportTemplate'):
          this.downloadTemplate()
          break
      }
    },
    beforeOrderUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 上传成功
    uploadOrderSuccess(res, file, fileList) {
      console.log('uploadOrderSuccess', res)
      if (res.ok) {
        const h = this.$createElement
        this.$msgbox({
          title: this.$t('common.tips.prompt'),
          message: h('p', null, [
            h('p', { style: 'fontSize: 20px;paddingBottom:5px' }, this.$t('CargoMsg.Cargo_ImportingData')),
            h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
          ]),
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'success'
        })
      } else {
        this.$confirm(res.message, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          canCloseModule: true,
          type: 'warning'
        })
      }
    },
    // 下载导出订单模板
    downloadTemplate() {
      // ExportUtils.downloadOrderTemplateFile(this.$store.getters.currentOfficeId, 'SI')
      // CARGO-39209 各个业务类型批量导入模板中，各模板加入样例文件
      this.downloadImportTemplateDialog.visible = true
    },
    // 是否协作业务
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode) {
        return true
      }
      return false
    },
    // 刷新表格
    refreshAgGrid() {
      this.gridApi.refreshCells({ force: true })
      this.gridApi.redrawRows()
    },
    // 批量修改自定义业务类型
    toBatchUpdateCustomType() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      const jobList = []
      for (const j of rows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (j.jobState !== SystemConstants.STATE_OPERATING.code) {
          this.$message.warning(this.$t(j.jobNo + this.$t('SeaExport.RecordNotPositiveOperationStatus')))
          return
        }
        jobKeys.push(j.uuid)
        jobList.push(j)
      }
      this.customJobTypeDialog.jobKeys = jobKeys
      this.customJobTypeDialog.jobList = jobList
      this.customJobTypeDialog.visible = true
    }, // 批量修改自定义业务类型点击确定
    customJobTypeClickHandler() {
      const jobs = this.customJobTypeDialog.jobList
      if (jobs != null && jobs.length > 0) {
        const obj = {}
        obj.jobUuids = this.customJobTypeDialog.jobKeys
        obj.customJobType = this.customJobTypeDialog.customJobType
        this.loading = getLoading()
        updateJobCustomJobType(obj).then(res => this.updateJobCustomJobTypeResult(res)).finally(() => {
          this.loading.close()
        })
      }
    },
    // 批量修改自定义业务类型 处理结果
    updateJobCustomJobTypeResult(res) {
      this.loading.close()
      if (res.data) {
        this.$message.success(this.$t('SeaExport.CustomJobTypeBatchModifySuccess') + res.data)
        for (const seaJob of this.customJobTypeDialog.jobList) {
          seaJob.customJobType = this.customJobTypeDialog.customJobType
        }
        this.refreshAgGrid()
      }
      this.customJobTypeDialog.visible = false
      this.customJobTypeDialog.customJobType = ''
      this.customJobTypeDialog.jobKeys = []
      this.customJobTypeDialog.jobList = []
    },
    // 批量修改业务
    toBatchModifyBusiness() {
      const rows = this.readSelectedRows()
      if (rows.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (rows.length > 200) {
        this.$message.warning(this.$t('SeaExport.maxSelectBusiness', ['200']))
        return
      }
      this.batchModifyBusinessDialog.lob = this.lob
      this.batchModifyBusinessDialog.jobList = rows
      this.batchModifyBusinessDialog.jobKeys = Array.from(rows, p => p.uuid)
      this.batchModifyBusinessDialog.visible = true
    },
    // 批量修改业务成功后，弹窗回调
    batchModifyBusinessCallback() {
      this.toQuery()
    },
    // 批量更换SOP模板
    toBatchUpdateSopTemplate() {
      const rows = this.readSelectedRows()
      JobUtils.batchUpdateSopTemplate(this, rows)
    },
    // 批量发起协作
    toBatchCooperation() {
      this.batchCooperationDialog.jobList = this.readSelectedRows()
      this.batchCooperationDialog.visible = true
    },
    reload() {
      this.toQuery()
    },
    onGridSelectionChanged(event) {
      const allRow = event.api.getSelectedRows()
      this.selectedRows = []
      for (const row of allRow) {
        if (!row) {
          continue
        }
        if (Number(row.dataType) === 1 || Number(row.dataType) === 2) {
          this.selectedRows.push(row)
        }
      }
      this.selectedRowCount = this.selectedRows.length
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    onPayInfoImportClick(e) {
      if (!this.checkHierarchyMulitple()) {
        e.stopPropagation()
      }
    },
    async onCarrierIdSelectionChange(data) {
      this.transshipDialog.txtCarrierId = data.cmpIdx
      await this.getVesselCarrier()
    },
    clearCheckBoxChange(key = '') {
      switch (key) {
        case 'carrierId':
          if (this.clearCheckBox.carrierId) {
            this.transshipDialog.carrierId = 0
            this.transshipDialog.txtCarrierId = ''
          }
          break
        case 'bookingAgent':
          if (this.clearCheckBox.bookingAgent) {
            this.transshipDialog.bookingAgent = 0
            this.transshipDialog.txtBookingAgent = ''
          }
          break
        case 'vessel':
          if (this.clearCheckBox.vessel) {
            this.transshipDialog.voyageFlight = ''
          }
          break
        case 'voyageFlight':
          if (this.clearCheckBox.voyageFlight) {
            this.transshipDialog.voyageFlight = ''
          }
          break
        case 'loadingPortCode':
          if (this.clearCheckBox.loadingPortCode) {
            this.transshipDialog.loadingPortCode = ''
          }
          break
        case 'dischargingPortCode':
          if (this.clearCheckBox.dischargingPortCode) {
            this.transshipDialog.dischargingPortCode = ''
          }
          break
        case 'etd':
          if (this.clearCheckBox.etd) {
            this.transshipDialog.etd = ''
          }
          break
        case 'eta':
          if (this.clearCheckBox.eta) {
            this.transshipDialog.eta = ''
          }
          break
        case 'atd':
          if (this.clearCheckBox.atd) {
            this.transshipDialog.atd = ''
          }
          break
        case 'ata':
          if (this.clearCheckBox.ata) {
            this.transshipDialog.ata = ''
          }
          break
        default:
      }
    },
    toChangeSchema() {
      // 先打开费用方案弹框，选择方案后再带入到新增费用弹框
      this.toImportCharge()
    },
    // 处理费用方案选择
    handleSelectedScheme(selectedScheme) {
      // 关闭费用方案弹框
      this.chargeSchemeBatchDialog.visible = false
      // 打开新增费用弹框，并带入选择的费用方案
      this.addChargeDetailDialog.selectedJobs = this.readSelectedRows()
      this.addChargeDetailDialog.chargeType = this.chargeTypeDialog.type
      this.addChargeDetailDialog.selectedScheme = selectedScheme
      this.addChargeDetailDialog.visible = true
    }
  }
}
</script>

<style lang="scss">
  #app #booking-tree-grid {

  }
</style>
